import common from './common'
import featuresPay from './feature'

const tr = {
    featuresPay,
    common,
    SerialNumberDrawer: {
        productVariants: "Ürün/Varyantlar",
        serialNumber: "Seri Numarası",
        noProductsFound: "Ürün bulunamadı",
        searchByProductSku: "Ürün/SKU ile ara",
        searchSerialNumbers: "Seri numaralarını ara",
        transactionDetails: "İşlem Detayları",
        notAvailable: "Mevcut Değil",
        mainWarehouse: "Ana Depo"
    },
    new_build_banner: {
        title: 'Yeni sürüm:',
        is_available: 'artık yayında',
        fallback_title: 'Uygulamanın yeni bir sürümü mevcut',
        desc: 'En son özellikleri ve iyileştirmeleri almak için yenileyin.',
        refreshing: 'Yenileniyor…',
        refresh_now: 'Şimdi Yenile',
        later: 'Sonra',
        you_are_on: "kullandığınız sürüm"
    },
    short: {
        finance: 'Finans',
        stock: 'Stok'
    },
    onboarding: {
        welcome: 'Hoş Geldiniz!',
        step: {
            product: {
                totalBreakdown: 'Toplam Döküm',
                overallFulfilment: 'Genel Karşılama',
                totalShippedQty: 'Toplam Gönderilen Miktar',
                totalReceivedQty: 'Toplam Alınan Miktar',
                totalOrderedQty: 'Toplam Sipariş Edilen Miktar',
                totalShippedOrdered: 'Toplam Gönderilen / Sipariş Edilen',
                totalReceivedOrdered: 'Toplam Alınan / Sipariş Edilen',
                viewQty: 'Miktarı Görüntüle',
                fetchingQty: 'Miktar ayrıntıları alınıyor...',
                noStockInfo: 'Stok bilgisi bulunamadı',
                title: '%65 Tamamlandı',
                description: 'Büyük başarınıza başlamak için sadece 2 adım kaldı!',
                Warehouse: "Depo",
            },
            stock: {
                title: '%95 Neredeyse Bitti!!',
                description: 'Büyük başarınıza başlamak için sadece bir adım kaldı! Şimdi tamamlayın.'
            }
        },
        business: {
            title: 'İşletme başarıyla oluşturuldu!',
            description: 'Harika! İşletmeniz kaydedildi'
        },
        product: {
            title: 'İlk ürününüzü ekleyin',
            description: 'Stok kaydına başlamak için bir ürün ekleyin',
            Warehouse: "Depo",
        },
        stock: {
            title: 'Stok eklemeyi deneyin',
            description: 'Giriş ve çıkış stoklarını kaydetmeye başlayın'
        },
        action: {
            add_business: {
                title: 'İşletme Oluştur',
                description: 'Yeni bir işletme oluşturmak ister misiniz? Buraya tıklayın'
            },
            join_business: {
                title: 'İşletmeye Katıl',
                description: 'Davetiye kodunuz mu var? Buradan katılın'
            }
        }
    },
    business: {
        title: 'Bir işletme seçin, yeni oluşturun veya katılın',
        add_business: {
            title: 'Yeni işletme oluştur',
            name: 'İşletme Adı',
            name_placeholder: 'Ad girin',
            category: 'İşletme Kategorisi',
            category_placeholder: 'Kategori Seç',
            button: 'İşletme Oluştur'
        },
        edit_business: {
            title: 'İşletmeyi Düzenle'
        },
        join_business: {
            title: 'İşletmeye Katıl',
            input_code: 'Aşağıya davetiye kodunu girin:',
            field_placeholder: 'Davetiye kodu',
            confirm_title: 'Katıl',
            confirm_text: 'Şu işletmenin ekibi üyesi olacaksınız: '
        },
        no_business: 'Kullanılabilir işletme yok',
        create_or_join: 'İşletme oluşturun veya katılın',
        message: {
            saved: 'İşletme başarıyla kaydedildi!'
        },
        settings: {
            isNegativeTransactionDisabled: 'Negatif stok işlemleri',
            isNegativeTransactionDisabledHint: 'Bunu açarak, negatif stokla sonuçlanacak işlemleri engelleyebilirsiniz.',
            negativeStockError: 'Negatif stok işlemleri devre dışı bırakıldı'
        }
    },
    profile: {
        edit_profile: {
            title: 'Profili Düzenle',
            name: 'Tam Ad',
            name_placeholder: 'Tam adınızı girin',
            email: 'E-posta',
            phone_number: 'Telefon Numarası'
        },
        message: {
            required_name: 'Ad zorunludur'
        }
    },
    product: {
        weightedAverageCost: 'Ağırlıklı Ortalama Maliyet',
        weightedAverageValueLabel: 'Ağırlıklı Ortalama Değer',
        Product: 'Ürün',
        hideZeroStock: 'Sıfır Stoğu Gizle',
        allVariants: 'Tüm Varyantlar',
        choose_product: 'Ürün Seç',
        choose_product_empty: 'Ürün seçin ve miktarı girin',
        choose_product_empty_manufacturing: 'Ürün seçin ve üretim miktarını girin',
        search: {
            placeholder: 'İsme göre ara',
            tooltip: 'Tarayıcıyı aç',
            Warehouse: "Depo",
        },
        column: {
            image: 'Fotoğraf',
            name: 'Ad',
            price: 'Fiyat',
            buying_price: 'Maliyet Fiyatı',
            selling_price: 'Satış Fiyatı',
            sku: 'Ürün Kodu',
            stock: 'Stok',
            quantity: 'Miktar',
            latest_stock: 'Kalan',
            product_deleted: 'Ürün silindi',
            info_not_found: 'Bilgi mevcut değil',
            expired_date: 'Son Kullanma Tarihi',
            invoice: 'Fatura'
        },
        no_product: 'Ürün Bulunamadı',
        no_product_subtitle: 'Stok, fiyatlandırma ve satışları takip etmeye başlamak için ilk ürününüzü ekleyin.',
        create_first_product: 'İlk ürününüzü oluşturun',
        add_product: {
            sku: 'Ürün Kodu',
            sku_placeholder: 'Ürün Kodu. Örnek: 12345',
            name: 'Ürün Adı',
            name_placeholder: 'Ürün Adı Girin',
            initial_stock: 'Başlangıç Stoğu',
            initial_stock_placeholder: 'Başlangıç Stoğunu Girin',
            buying_price: 'Maliyet Fiyatı',
            buying_price_placeholder: 'Maliyet Fiyatını Girin',
            selling_price: 'Satış Fiyatı',
            selling_price_placeholder: 'Satış Fiyatını Girin',
            category: 'Kategori',
            category_placeholder: 'Kategori Seç',
            add_selling_price: 'Toptan Satış Fiyatı Ekle',
            expired_date: 'Son Kullanma Tarihi',
            expired_date_placeholder: 'Tarih Seç',
            description: 'Açıklama',
            description_placeholder: 'Açıklama Girin',
            custom_label: 'Özellik',
            custom_label_placeholder: 'Anahtar Girin',
            add_custom_label: 'Daha Fazla Özellik Ekle',
            Warehouse: "Depo",
        },
        customerLabel: {},
        choose_selling_price: 'Satış Fiyatı Seç',
        selling_price: 'Satış Fiyatı',
        total_product: 'Toplam Ürün',
        total_quantity: 'Toplam Stok',
        total_buying_price: 'Toplam Maliyet Fiyatı',
        total_selling_price: 'Toplam Satış Fiyatı',
        message: {
            required_name: 'Ürün adı zorunludur',
            required_sku: 'Ürün kodu zorunludur',
            required_category: 'Kategori zorunludur',
            required_quantity: 'Başlangıç stoğu zorunludur',
            invalid_input_qty: 'Geçersiz stok miktarı',
            required_buying_price: 'Maliyet fiyatı zorunludur',
            required_selling_price: 'Satış fiyatı zorunludur',
            required_selling_price_name: 'Satış fiyatı adı zorunludur',
            required_selling_price_price: 'Satış fiyatı zorunludur'
        },
        viewMore: 'Daha Fazla Göster',
        WarehouseDetails: 'Depo Detayları',
        WarehouseName: 'Depo Adı',
        AddWarehouse: 'Depo Ekle',
        WarehouseQty: 'Depo Miktarı',
        Warehouse: 'Depo',
        Warehouses: 'Depolar',
        Variants: 'Varyantlar',
        VariantName: 'Varyant Adı',
        productVariant: 'Ürün Varyantları',
        AddVariant: 'Varyant Ekle',
        TranferItem: 'Ürün Transfer Et',
        AddUnit: 'Yeni Birim',
        InitialStkWarehouse: 'Varyant eklemek için başlangıç stoğu zorunludur',
        InitialStockinwarehouse: 'Depodaki Başlangıç Stoğu',
        TotalQuantity: 'Toplam Miktar:',
        AddNote: 'Not Ekle (Maliyet Fiyatı)',
        AddNotetitle: 'Not Ekle',
        VariantSuccessMessage: 'Ürün varyantı başarıyla güncellendi',
        Next: 'İleri',
        Submit: 'Gönder',
        INACTIVE: 'PASİF',
        errorone: 'Oops! Talep edilen miktar',
        errortwo: 'ayrılan depo miktarlarıyla eşleşmiyor. Lütfen miktarı ayarlayın veya stoğu yenileyin.',
        SelectWarehouse: 'Depo Seç',
        SelectVariant: 'Varyant Seç',
        Discount: 'İndirim',
        DiscountDetails: 'İndirim Detayları',
        FinalPrice: 'Son Fiyat',
        DiscountType: 'İndirim Türü',
        DiscountPer: 'İndirim %',
        DiscountValue: 'İndirim Tutarı',
        Discountonprice: 'Fiyat üzerinden indirim',
        Discountondiscount: 'İndirim üzerinden indirim',
        AdditionalDiscount: 'Ek İndirim',
        SellingPrice: 'Satış Fiyatı:',
        Save: 'Kaydet',
        OnOriginalPrice: 'Orijinal Fiyat Üzerinden',
        OnDiscountedPrice: 'İndirimli Fiyat Üzerinden',
        columnSelector: {
            title: 'Sütunları Göster',
            columnsButton: 'Sütunlar',
            costPrice: 'Maliyet Fiyatı',
            sellingPrice: 'Satış Fiyatı',
            sku: 'SKU',
            warehouse: 'Depo',
            categories: 'Kategoriler',
            safetyStock: 'Güvenlik Stoğu',
            attributes: 'Öznitelikler',
            notes: 'Notlar',
            description: 'Açıklama',
            more: 'daha fazla',
            attribute: 'Öznitelik',
            attributesTitle: 'Öznitelikler',
            categoriesTitle: 'Kategoriler',
            skuAliases: 'SKU Takma Adları'
        }
    },
    note: {
        title: 'Notlar',
        add: 'Not Ekle',
        no_note: 'Not bulunamadı'
    },
    settings: {
        category: 'Kategori',
        language: 'Dil',
        switch_business: 'İşletme Değiştir',
        currencySelect: 'Para Birimi',
        languageChangeSuccess: 'Para Birimi Başarıyla Güncellendi',
        languageChangeErrorMessage: 'Para Birimi Güncellenirken Bir Hata Oluştu',
        currencyAdded: "Para birimi başarıyla eklendi",
        currencyDelete: "Para birimi başarıyla silindi",
        Selectyourpreferredlanguage: "Tercih ettiğiniz dili seçin",
    },
    selectProductStock: 'Ürün Seç',
    category: {
        category_list: {
            title: 'Ürün Kategorileri'
        },
        add_category: {
            button: 'Yeni Kategori',
            title: 'Yeni Kategori Ekle'
        },
        edit_category: {
            title: 'Kategoriyi Düzenle'
        },
        name: 'Kategori Adı',
        name_placeholder: 'Kategori Adı Girin',
        no_category: 'Kategori bulunamadı'
    },
    staff: {
        add: 'Personel Ekle',
        edit: 'Personeli Düzenle',
        access: {
            stock: 'Stok',
            add_product: 'Yeni ürün ekle',
            edit_product: 'Ürün düzenle',
            delete_product: 'Ürün sil',
            view_capital_price: 'Maliyet Fiyatını Görüntüle',
            add_category: 'Yeni kategori ekle',
            edit_category: 'Kategori düzenle',
            delete_category: 'Kategori sil',
            add_supplier: 'Yeni tedarikçi ekle',
            edit_supplier: 'Tedarikçi düzenle',
            delete_supplier: 'Tedarikçi sil',
            add_customer: 'Yeni müşteri ekle',
            edit_customer: 'Müşteri düzenle',
            delete_customer: 'Müşteri sil',
            add_staff: 'Personel ekle',
            edit_staff: 'Personel düzenle',
            delete_staff: 'Personel sil',
            change_business_profile: 'İşletme profilini değiştir',
            access_by_product_category: 'Ürün Kategorisine Göre Erişim',
            no_category_message: 'Henüz kategori eklenmemiş. Lütfen kategori listesi ekleyin.',
            expenses: 'Giderler',
            view_expenses: 'Giderleri Görüntüle',
            add_expenses: 'Gider Ekle',
            edit_expenses: 'Gider Düzenle',
            delete_expenses: 'Gider Sil',
            warehouse: 'Depo',
            add_new_warehouse: 'Yeni Depo Ekle',
            edit_warehouse: 'Depo Düzenle',
            delete_warehouse: 'Depo Sil',
            transfer_warehouse: 'Depo Transferi',
            transfer_warehouse_approval: 'Depo Transfer Onayı',
            access_by_warehouse: 'Depoya Göre Erişim',
            no_warehouse_message: 'Henüz depo eklenmemiş. Lütfen depo listesi ekleyin.',
            purchase_order: "Satın alma siparişi",
            purchase_order_creation: "Satın alma siparişi oluşturma",
            purchase_order_edit: "Satın alma siparişi düzenle",
            purchase_order_cancel: "Satın alma siparişi iptal",
            purchase_order_reopen: "Satın alma siparişi yeniden aç",
            purchase_order_receive: "Satın alma siparişi alındı",
            sales_order: "Satış siparişi",
            sales_order_creation: "Satış siparişi oluşturma",
            sales_order_edit: "Satış siparişi düzenle",
            sales_order_cancel: "Satış siparişi iptal",
            sales_order_reopen: "Satış siparişi yeniden aç",
            sales_order_receive: "Satış siparişi gönderildi",
            purchase_order_approval: "Satın alma siparişi onayı",
            sales_order_approval: "Satış siparişi onayı",
            can_do_available_warehouse: "Mevcut depo",
            add_batch: "Batch oluşturma onayı"
            ,
            notification: 'Bildirim',
            staffNotification: 'Bildirimi Etkinleştir',
            assignee: "Atanan",
        },
        no_staff: 'Personel bulunamadı.'
    },
    code: {
        title: 'Yeni Personel Eklendi!',
        subtitle: 'Katılmak için aşağıdaki davet kodunu paylaşın:',
        valid: 'Kod sadece 48 saat geçerlidir',
        share: 'WhatsApp ile Paylaş',
        copied: 'Kopyalandı!',
        invalid: 'Geçersiz kod!'
    },
    history: {
        no_history: 'Geçmiş yok.',
        detail: {
            remove: 'Geçmişi Kaldır',
            confirm: 'Bu işlem mevcut stok, geçmiş ve raporları etkileyecektir.'
        },
        no_history_selected: "Hiçbir geçmiş seçilmedi",
        select_history_hint: "Detayları görmek için listeden bir geçmişe tıklayın",
        select_from_left: "Sol panelden seçin",
    },
    supplier: {
        add: {
            title: 'Tedarikçi Ekle'
        },
        edit: {
            title: 'Tedarikçiyi Düzenle'
        },
        new: 'Yeni tedarikçi',
        no_supplier: 'Tedarikçi bulunamadı.',
        bank: {
            title: 'Banka Bilgileri'
        },
        note: 'Notlar',
        form: {
            name: {
                label: 'Tedarikçi Adı',
                placeholder: 'Tedarikçi Adı Girin',
                placheolder_not_mandatory: 'Ad girin ',
                error: {
                    required: 'Ad boş bırakılamaz'
                }
            },
            contact: {
                label: 'İletişim Numarası',
                placeholder: '905xxxxxxxxx',
                error: {
                    required: 'İletişim numarası boş bırakılamaz',
                    invalid: 'Geçersiz numara. Ülke kodu ile birlikte olmalıdır'
                }
            },
            bank_name: {
                label: 'Banka Adı',
                placeholder: 'Banka Adı Girin'
            },
            bank_account_name: {
                label: 'Hesap Sahibi Adı',
                placeholder: 'Hesap Sahibi Adını Girin'
            },
            bank_account_number: {
                label: 'Hesap Numarası',
                placeholder: 'Hesap Numarasını Girin'
            },
            note: {
                label: 'Notlar',
                placeholder: 'Not Ekleyin'
            },
            openingBalance: {
                addBtn: 'Açılış Bakiyesi Ekle',
                label: 'Açılış Bakiyesi',
                placeholder: 'Açılış Bakiyesi Girin',
                error: {
                    negative: 'Açılış bakiyesi negatif olamaz'
                }
            }
        },
        choose: 'Tedarikçi Seç'
    },
    customer: {
        add: {
            title: 'Müşteri Ekle'
        },
        edit: {
            title: 'Müşteriyi Düzenle'
        },
        new: 'Yeni müşteri',
        no_customer: 'Müşteri bulunamadı.',
        note: 'Notlar',
        form: {
            name: {
                label: 'Müşteri Adı',
                placeholder: 'Müşteri Adı Girin',
                placheolder_not_mandatory: 'Ad girin ',
                error: {
                    required: 'Ad boş bırakılamaz'
                }
            },
            contact: {
                label: 'İletişim Numarası',
                placeholder: '905xxxxxxxxx',
                error: {
                    required: 'İletişim numarası boş bırakılamaz',
                    invalid: 'Geçersiz numara. Ülke kodu ile birlikte olmalıdır'
                }
            },
            address: {
                label: 'Adres',
                placeholder: 'Adres Girin'
            },
            note: {
                label: 'Notlar',
                placeholder: 'Not Ekleyin'
            },
            openingBalance: {
                addBtn: 'Açılış Bakiyesi Ekle',
                label: 'Açılış Bakiyesi',
                placeholder: 'Açılış Bakiyesi Girin',
                error: {
                    negative: 'Açılış bakiyesi negatif olamaz'
                }
            }
        },
        choose: "Müşteri Seç",
        report: {
            view: 'Alıcı Raporunu Görüntüle',
            title: 'Müşteri Raporu',
            no_report: 'Seçilen tarihte alıcılar için rapor bulunmamaktadır.',
            column: {
                name: 'Ad',
                total_transaction: 'Toplam İşlem',
                total_amount: 'Toplam Satış',
                total_profit: 'Toplam Kâr'
            }
        }
    },
    confirm_delete: 'Bu veriyi silmek istediğinizden emin misiniz?',
    report: {
        title: 'Rapor'
    },
    accounting: {
        download_pdf_report: 'PDF İndir',
        title: 'Muhasebe',
        view_report: 'Finansal Raporu Görüntüle',
        dashboard_title: 'Finansal Rapor',
        stats: 'İstatistikler',
        accounting_report: 'Muhasebe Raporu',
        filter: {
            date: {
                placeholder: 'Tarih Seç',
                submit: 'Uygula',
                cancel: 'Filtreyi Sıfırla'
            },
            timeframe: {
                day: 'Günlük',
                week: 'Haftalık',
                month: 'Aylık',
                year: 'Yıllık'
            }
        },
        total_sales: 'Toplam Satış',
        total_purchases: 'Toplam Alış',
        total_profit: 'Toplam Kâr',
        total_expenses: 'Toplam Gider',
        assets_value: 'Mevcut Varlık Değeri',
        total_current_cogs_value: 'Toplam Güncel COGS Değeri',
        current_asset_selling_price: 'Güncel Varlık Satış Fiyatı',
        total_selling_price: 'Toplam Satış Fiyatı',
        table: {
            date: 'Tarih',
            sales: 'Satış',
            purchases: 'Alış',
            profit: 'Kâr',
            expenses: 'Gider'
        },
        no_data: 'Veri bulunamadı.'
    },
    stock_report: {
        title: 'Stok Raporu',
        view: 'Stok Raporunu Görüntüle',
        no_report: 'Seçilen tarih veya personel için stok kaydı bulunmamaktadır.',
        allStaffPlaceHolder: 'Tüm Personel',
        column: {
            total_product: 'Mevcut Ürün Çeşidi',
            total_product_quantity: 'Toplam Mevcut Ürün Miktarı'
        }
    },
    subscription: {
        paywall_small: {
            title: 'VIP Özellik',
            description:
                'Bu özelliğin deneme süresi sona erdi. Yerel uygulamanın gelişimini desteklemek için abone olun.',
            button: 'Abonelik Planlarını Görüntüle'
        }
    },
    payment: {
        order: {
            title: 'Ödeme'
        }
    },
    imageUploadMessage: {
        uploadSize: 'Resim boyutu 5MB\'ı geçmemelidir!',
        failedMessage: 'Ürün resmi yüklenemedi, lütfen tekrar deneyin!',
        successUpload: 'Resim başarıyla yüklendi!',
        failedUIError: 'Resim silinemedi, lütfen tekrar deneyin!',
        SuccessErrorImage: 'Resim başarıyla silindi!'
    },
    productColumns: {
        SKULabel: 'Ürün Kodu',
        nameLabel: 'Ürün Adı',
        categoryLabel: 'Kategori',
        BuyingPriceLabel: 'Alış Fiyatı',
        SellingLabel: 'Satış Fiyatı',
        StockLabel: 'Stok'
    },
    historyColumns: {
        Transactionlabel: 'İşlem Türü',
        Locallabel: 'Yerel Saat',
        Createdlabel: 'Oluşturan',
        Vendorlabel: 'Tedarikçi Adı',
        Buyerlabel: 'Alıcı Adı',
        SKUlabel: 'Ürün Kodu',
        Invoicelabel: 'Fatura',
        Productlabel: 'Ürün Adı',
        Categorylabel: 'Kategori',
        Buyinglabel: 'Alış Fiyatı',
        Sellinglabel: 'Satış Fiyatı',
        Initiallabel: 'Başlangıç Stoğu',
        Finallabel: 'Son Stok',
        Stocklabel: 'Stok Değişimi'
    },
    stockReportColumns: {
        skuLabel: 'Ürün Kodu',
        productNameLabel: 'Ürün Adı',
        categoryLabel: 'Kategori',
        buyingPriceLabel: 'Alış Fiyatı',
        sellingPriceLabel: 'Satış Fiyatı',
        stockInLabel: 'Stok Giriş',
        stockOutLabel: 'Stok Çıkış',
        remainingStockLabel: 'Kalan Stok',
        openStockLabel: 'Açık Stok',
        weightedAverageCost: 'Ağırlıklı Ortalama Maliyet',
        weightedAverageCostLabel: 'Ağırlıklı Ortalama Maliyet',
        weightedAverageValueLabel: 'Ağırlıklı Ortalama Değer'
    },
    accountingReportColumns: {
        dateRange: 'Tarih aralığı',
        reportingPeriod: 'Raporlama Dönemi',
        reportGenerate: 'Rapor Oluştur',
        warehouse: 'Depo',
        labelDate: 'Tarih',
        labelSales: 'Satış',
        labelPurchases: 'Alış',
        labelProfit: 'Kâr',
        labelExpenses: 'Giderler',
        reportOptions: 'Rapor Sütunları',
        summaryCards: 'Özet Kartları',
        grandTotal: 'Genel Toplam',
        continued: 'devam',
        subtotal: 'Ara Toplam',
        page: 'Sayfa'
    },
    customerReportColumns: {
        labelName: 'Ad',
        labelTotalTransaction: 'Toplam İşlem',
        labelTotalSales: 'Toplam Satış',
        labelTotalProfit: 'Toplam Kâr'
    },
    scannerDialog: {
        finished: 'Tamamlandı',
        reduce: 'Azalt',
        successfull: 'Başarılı',
        searching: 'Aranıyor...',
        title: 'Tarayıcı aktif. Barkoda yöneltin!'
    },
    historyFilter: {
        SelectBuyer: 'Alıcı Seç',
        SelectVendor: 'Tedarikçi Seç'
    },
    productStockFilter: {
        StockLowtoHigh: 'Stok Azdan Çoka',
        StockHightoLow: 'Stok Çoktan Aza',
        AlphabetAZ: 'Alfabetik A-Z',
        AlphabetZA: 'Alfabetik Z-A'
    },
    minimizeTitle: 'Tarayıcı aktif',
    security_guarantee: {
        title: 'Veri Güvenliği Garantili'
    },
    invoice: {
        invoicePlaceholder: 'Fatura Numarası',
        invoiceTitle: 'Fatura',
        manageInvoiceAddress: 'Fatura Adresini Yönet',
        selectOrManageAddresses: 'Özel fatura adreslerini seçin, düzenleyin veya oluşturun',
        useBusinessProfileAddress: 'İşletme Profili Adresini Kullan',
        noCustomAddressesFound: 'Özel Adres Eklenmedi',
        createCustomAddressDesc: 'Faturalarınıza varsayılan işletme profili verilerinin yerine yazdırmak için özel fatura veya şube adresleri ekleyin.',
        defaultFromBusinessProfile: 'İşletme Profilinden Varsayılan',
        editInvoiceAddress: 'Fatura Adresini Düzenle',
        createNewInvoiceAddress: 'Yeni Fatura Adresi Oluştur',
        logoHeaderImage: 'Logo / Başlık Görseli',
        deleteInvoiceAddress: 'Fatura Adresi Silinsin mi?',
        deleteAddressConfirmText: 'Bu fatura adresini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.'
    },
    ManageInvoiceAddress: 'Fatura Adresini Yönet',
    SelectOrManageAddresses: 'Özel fatura adreslerini seçin, düzenleyin veya oluşturun',
    UseBusinessProfileAddress: 'İşletme Profili Adresini Kullan',
    CreateNewAddress: 'Yeni Adres Oluştur',
    UpdatingList: 'Liste güncelleniyor...',
    NoCustomAddressesFound: 'Özel Adres Eklenmedi',
    CreateCustomAddressDesc: 'Faturalarınıza varsayılan işletme profili verilerinin yerine yazdırmak için özel fatura veya şube adresleri ekleyin.',
    DefaultFromBusinessProfile: 'İşletme Profilinden Varsayılan',
    EditInvoiceAddress: 'Fatura Adresini Düzenle',
    CreateNewInvoiceAddress: 'Yeni Fatura Adresi Oluştur',
    LogoHeaderImage: 'Logo / Başlık Görseli',
    UploadingImage: 'Görsel Yükleniyor...',
    UploadImage: 'Görsel Yükle',
    BusinessName: 'İşletme Adı',
    AddressDetails: 'Adres Detayları',
    PhoneNumber: 'Telefon Numarası',
    EmailAddress: 'E-posta Adresi',
    DeleteInvoiceAddress: 'Fatura Adresi Silinsin mi?',
    DeleteAddressConfirmText: 'Bu fatura adresini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',

    stocklowreport: {
        no_stocklowreport_one: 'Güvenlik stoğu ayarlanmış ürün yok.',
        no_stocklowreport_two: 'Lütfen güvenlik stoğu miktarı ekleyin.',
        currentStock: 'Mevcut Stok',
        safetyStock: 'Güvenlik Stoğu',
        pricing: 'Fiyatlandırma',
        costPrice: 'Maliyet Fiyatı',
        sellingPrice: 'Satış Fiyatı',
        productInfo: 'Ürün Bilgileri',
        category: 'Kategori',
        description: 'Açıklama',
        no_description: 'Açıklama eklenmedi',
        variants: 'Varyantlar',
        unitsOnHand: 'eldeki birimler',
        minimumThreshold: 'minimum eşik',
        adjust: 'Düzenle',
        all: 'Tümü',
        lowStock: 'Düşük Stok',
        variantsDetails: 'Varyant Detayları',
        qty: 'Miktar',
        addSafetyStock: 'Güvenlik Stoğu Ekle',
        searchByNameSku: 'İsim/SKU ile ara',
        safetyStockShort: 'G',
        warehouseSafetyStock: 'Depo Güvenlik Stoğu'
    },
    low_alert_stock: 'Güvenlik stoğu miktarını girin',
    lowStockAlertNotify: "Stok belirlenen miktarın altına düştüğünde bildirim alacaksınız",
    applyButtonStockAlert: 'Uygula',
    cancelButtonStockAlert: 'İptal',
    searchProductLabel: 'Ürün ara...',
    successfullyAddedSafetyStock: 'Güvenlik stoğu başarıyla güncellendi',
    safety_Stock: 'Güvenlik Stoğu',
    safety_stock_placeholder: 'Güvenlik Stoğu Girin',
    lowStockDetailsInfo: {
        ProductCode: 'Ürün Kodu',
        SafetyStock: 'Güvenlik Stoğu',
        Stock: 'Stok',
        CostPrice: 'Maliyet Fiyatı',
        SellingPrice: 'Satış Fiyatı',
        Category: 'Kategori',
        Description: 'Açıklama',
        ExpirationDate: 'Son Kullanma Tarihi'
    },
    CustomLang: {
        Attribute: 'Özellik',
        AddAttribute: 'Özellik Ekle',
        EditAttribute: 'Özelliği Düzenle',
        CustomLabePlaceholder: 'Özellik Adı Girin',
        CustomLabePlaceholderSelect: 'Tür Seç',
        AddMoreAttribute: 'Daha Fazla Özellik Ekle',
        ItemAttribute: 'Ürün Özelliği',
        TableName: 'Ad',
        TableType: 'Tür',
        TableAction: 'İşlem',
        TableDelete: 'Sil',
        TableEdit: 'Düzenle',
        deleteMessage: 'Özellik başarıyla silindi',
        editSuccessMessage: 'Özellik başarıyla güncellendi',
        AddSuccessMessage: 'Özellik başarıyla eklendi',
        AddAtt: 'Ekle',
        EditAtt: 'Düzenle',
        SubmitAtt: 'Gönderiliyor...'
    },
    Expenses: {
        ExpensesTitle: 'Giderler',
        AddExpenses: 'Gider Ekle',
        ExpenseCategory: 'Gider kategorisi',
        NoExpenseCategory: 'Gider kategorisi yok',
        AddExpenseCategory: 'Gider kategorisi ekle',
        SelectExpenseCategory: 'Gider kategorisi seç',
        NoExpenses: 'Gider yok',
        ExpensesSuccess: 'Gider başarıyla oluşturuldu',
        ExpensesSuccessEdit: 'Gider başarıyla güncellendi',
        ExpensesCategoryName: 'Gider kategori adı',
        ExpensesSuccessDelete: 'Gider başarıyla silindi',
        AddNEC: 'Yeni Gider Kategorisi Ekle',
        NC: 'Yeni Gider Kategorisi',
        EditNEC: 'Gider Kategorisini Düzenle'
    },
    Manufacturing: {
        ProducedProduct: "Üretilen Ürün",
        QuantityManufactured: "Üretilen Miktar",
        UnitCost: "Birim Maliyet",
        RawMaterialsTotal: "Toplam Ham Madde",
        TotalManufacturingCost: "Toplam Üretim Maliyeti",
        NoRawMaterialsConsumed: "Tüketilen ham madde yok.",
        CostBreakdown: "Maliyet Detayı",
        GeneratedBatch: "Üretilen Parti",
        StoredBinLocation: "Depolanan Bölme Konumu",
        NoManufacturingTransactionsFound: "Üretim işlemi bulunamadı",
        AddManufacture: 'Üretim Detaylarını Ekle',
        Manufacturing: 'Üretim',
        RawMaterials: 'Hammadde',
        AdditonCosts: 'Ek Maliyetler',
        RawMaterial: 'Hammadde',
        AdditonCost: 'Ek Maliyet',
        TotalCost: 'Toplam Maliyet',
        AddRawMaterial: 'Hammadde ekle (şu ürün için)',
        AddAdditonCost: 'Ek maliyet ekle (şu ürün için)',
        AddMore: 'Daha fazla ekle',
        Add: 'Ekle',
        Update: 'Güncelle',
        Updating: 'Gönderiliyor...',
        ProductRequired: 'Ürün zorunludur',
        QuantityRequired: 'Miktar zorunludur',
        ChargeRequired: 'Ücret zorunludur',
        EstimatedCostRequired: 'Tahmini maliyet zorunludur',
        PurchasePriceRequired: 'Alış fiyatı zorunludur',
        SelectCharge: 'Ücret Türü Seç',
        EstimatedCost: 'Tahmini Maliyet',
        SelectProduct: 'Ürün Seç',
        Quantity: 'Miktar',
        ManufactureDetails: 'Üretim Detayları',
        BuyingPrice: 'Alış Fiyatı',
        LabourCharge: 'İşçilik Ücreti',
        ElectricityCost: 'Elektrik Maliyeti',
        PackagingCharge: 'Ambalaj Ücreti',
        LogisticCost: 'Lojistik Maliyeti',
        OtherCharges: 'Diğer Ücretler',
        Save: 'Detayları Kaydet',
        PurchasePrice: 'Alış Fiyatı',
        Date: 'Tarih',
        For: 'Ürün',
        PurchaseRate: 'Alış Oranı (Fiyat)',
        Scrolltoloadmore: 'Daha fazla yüklemek için kaydırın...',
        Noproductsfound: 'Ürün bulunamadı',
        ManufacturingQuantity: 'Üretim Miktarı',
        ManufactureAddedSuccess: 'Üretim detayları başarıyla güncellendi'
    },
    Warehouses: {
        transferOrder: 'Ürün Transferi',
        AddTransferOrder: 'Transfer Ürün Ekle',
        NewWarehouse: 'Yeni Depo',
        newHead: 'Birden fazla depoyu yönetmeye başlayın!',
        headTwo: 'Birden fazla depodaki envanterinizi sorunsuz takip edin ve yönetin',
        EnableWarehouse: 'DEPOYU ETKİNLEŞTİR',
        EnableWarehouse2: 'Depoyu Etkinleştir',
        OrganizationPrimary: "Organizasyonun Ana Deposu",
        Edit: 'Düzenle',
        AreEnableWarehouse: 'Depoyu etkinleştirmek istediğinizden emin misiniz?',
        Confirm: 'Onayla',
        Cancel: 'İptal',
        WarehouseCreatedSuccessfully: 'Depo başarıyla oluşturuldu',
        MarkAsOP: "Organizasyonun Ana Deposu Olarak İşaretle",
        MarkAsInAct: 'Pasif Yap',
        MarkAsAct: 'Aktif Yap',
        MarkedAsInactive: 'Depo pasif olarak işaretlendi',
        MarkedAsActive: 'Depo aktif olarak işaretlendi',
        MarkedAsOP: 'Depo aktif ve ana depo olarak işaretlendi',
        WareDeletedSuccess: 'Depo başarıyla silindi',
        SuccessfullyUpdatedWarehouse: 'Depo başarıyla güncellendi',
        SuccessfullyCreatedWarehouse: 'Depo başarıyla oluşturuldu',
        EditWarehouse: 'Depoyu Düzenle',
        AddWarehouse: 'Depo Ekle',
        WarehouseNameIsRequired: 'Depo adı zorunludur',
        EnterWarehouseName: 'Depo adını girin',
        EnterEmail: 'E-posta girin',
        EnterPhoneNumber: 'Telefon numarası girin',
        Location: 'Konum...',
        name: 'Depo adı',
        email: 'E-posta',
        phoneNumber: 'Telefon numarası',
        location: 'Konum',
        ViewProducts: 'Ürünleri Görüntüle',
        PageTitle: 'Depolar',
        noWarehouse: "Aramanızla eşleşen depo bulunamadı"
    },
    Assets: {
        headerTitle: 'Varlıklar',
        addAssetMessage: "Buradan varlık ekleyin. Bir varlığı personele atamak için ilgili personelin profiline gidin.",
        addAsset: 'Varlık Ekle',
        editAsset: 'Varlığı Düzenle',
        assetCode: 'Varlık Kodu',
        assetName: 'Varlık Adı',
        assetCategory: 'Varlık Kategorisi',
        assetType: 'Varlık Türü',
        serialNumber: 'Seri Numarası',
        location: 'Konum',
        condition: 'Durum',
        selectCondition: 'Durum Seç',
        fair: 'Orta',
        good: 'İyi',
        excellent: 'Mükemmel',
        poor: 'Kötü',
        notes: 'Notlar',
        submit: 'Gönder',
        submitting: 'Gönderiliyor',
        noCategory: 'Kategori yok',
        selectCategory: 'Kategori seç',
        addAssetCat: 'Varlık Kategorisi Ekle',
        addAssetCatName: 'Varlık kategori adı',
        edit: 'Düzenle',
        status: 'Durum',
        createdAt: 'Oluşturulma Tarihi',
        viewAsset: 'Varlığı Görüntüle',
        assignAsset: 'Varlık Ata',
        conditionRet: 'İade Durumu',
        searchSelectAssets: 'Varlık Ara/Seç',
        assetAssigned: 'Varlık başarıyla atandı',
        assetReturned: 'Varlık başarıyla iade edildi',
        selectAnAsset: 'Lütfen bir varlık seçin',
        action: 'İşlem',
        noAssetAssigned: 'Atanmış varlık yok',
        reAssigned: 'Yeniden Ata',
        assignedAssetsList: 'Atanmış Varlıklar Listesi',
        viewHistory: 'Geçmişi Görüntüle',
        history: 'Varlık Geçmişi',
        loadingHistory: 'Geçmiş yükleniyor...',
        loadingMore: 'Daha fazla yükleniyor...',
        dateTime: 'Tarih & Saat',
        staff: 'Personel',
        AssignedBy: 'Atayan',
        assign: 'ATA',
        return: 'İADE ET',
        unknown: 'BİLİNMEYEN',
        noHistory: 'Bu varlık için geçmiş bulunamadı.',
        enterReturnNote: 'İade için not girin',
        returnNote: 'İade Notu',
        enterAssignNote: 'Atama için not girin',
        assignNote: 'Atama Notu',
        AddNAC: "Yeni Varlık Kategorisi Ekle",
        EditNAC: "Varlık Kategorisini Düzenle",
        others: "Diğerleri"
    },
    LedgerTransaction: {
        ledgerDetails: 'Cari Hesap Detayları',
        productName: 'Ürün Adı',
        totalQty: 'Toplam Miktar',
        date: 'Tarih',
        receivedAmt: 'Alınan Tutar',
        paid: 'Ödenen',
        discount: 'İndirim',
        balance: 'Bakiye',
        more: 'daha fazla',
        total: 'Toplam',
        ledgerupdatedsuccessfully: 'Cari hesap başarıyla güncellendi',
        ledgeraddedsuccessfully: 'Cari hesap başarıyla eklendi',
        viewLedger: 'Cari Hesabı Görüntüle',
        edit: 'Düzenle',
        create: 'Oluştur',
        Recieved: 'Alınan [stok giriş]',
        payMode: 'Ödeme Şekli',
        Refno: 'Referans No'
    },
    ExtraField: {
        attachment: 'Ek',
        acceptOnlyImg: 'Sadece resim kabul edilir.',
        addAttribute: 'Özellik Ekle',
        acceptImgAndDoc: 'Resim ve belge kabul edilir.'
    },
    phoneInvoiceDownload: {
        Variant: 'Varyant',
        Warehouse: 'Depo',
        Bin: 'Bin',
        Batch: 'Parti',
        Attributes: 'Özellikler'
    },
    ImportExcel: {
        ImportStockfromExcel: "Excel'den Stok İçe Aktar",
        DragDrop: "Doldurulmuş Excel dosyanızı buraya sürükleyin veya göz atmak için tıklayın",
        DT: "Şablonu İndir",
        GB: "Geri Dön",
        Downloading: "İndiriliyor...",
        ChangeFile: "Dosyayı Değiştir",
        ReadingExcelfile: "Excel dosyası okunuyor...",
        Processing: "İşleniyor...",
        submitUpdateStock: "Gönder & Stoğu Güncelle",
        downloadLatestTemplate: "En Son Şablonu İndir",
        loginRequired: "Giriş Yapılması Gerekiyor"
    },
    stockForm: {
        recordPaymentNow: "Ödemeyi şimdi kaydet",
        recordPaymentDescCustomer: "Müşterinin ödediği tutarı girin",
        recordPaymentDescSupplier: "Tedarikçinin ödediği tutarı girin",
        managePayments: "Ödemeleri Yönet",
        invoice: "Fatura",
        challan: "İrsaliye",
        recordPayment: "Ödeme Kaydet",
        payableAmount: "Ödenecek Tutar",
        paidAmount: "Ödenen Tutar",
        paymentMethod: "Ödeme Yöntemi",
        paymentDate: "Ödeme Tarihi",
        reference: "Referans",
        billId: "Fatura Numarası",
        importExcel: "Excel'den İçe Aktar",
        noThanks: "Hayır, Teşekkürler",
        checkHistory: "Geçmişinizi Kontrol Edin",
        wantViewHistory: "Geçmişinizi görüntülemek ister misiniz?",
        enterPayable: 'Ödenecek Tutarı Girin',
        enterPaid: 'Ödenen Tutarı Girin',
        selectPayment: "Ödeme Yöntemi Seçin",
        attachment: "Ek Dosya",
        note: "Not"
    },
    HistoryEdit: {
        products: "Ürünler",
        add_product: "Ürün Ekle",
        paidAmountInvalidMessage: 'Ödenen tutar, ödenecek tutardan büyük olamaz',
        removingText: "Bu ürünü kaldırmak, işlem sırasında yapılan stok değişikliklerini geri alır.",
        remove: "Kaldır",
    },
    ExcelProduct: {
        uploadFile: "Dosya Yükle",
        dragDrop: "Excel dosyanızı buraya sürükleyin veya yüklemek için tıklayın.",
        parsingFile: "Dosya ayrıştırılıyor",
        fileSelected: "Dosya seçildi",
        reviewImportedData: "Aşağıdaki içe aktarılan verileri inceleyin. Sütunlar mümkün olduğunca otomatik eşleştirildi.",
        changeFile: "Dosyayı Değiştir",
        back: "Geri",
        invalidFileType: "Lütfen geçerli bir Excel dosyası yükleyin (.xlsx veya .xls)",
        parseExcelError: "Excel ayrıştırma hatası:",
        noData: "Yüklenen Excel dosyasında veri yok.",
        failedToRead: "Excel dosyası okunamadı. Lütfen tekrar deneyin.",
        Nodata: "VERI_YOK",
        unableToRead: "Dosya okunamadı.",
        buyingMustNumber: "Alış Fiyatı sayı olmalıdır",
        sellingMustNumber: "Satış Fiyatı sayı olmalıdır",
        mustBeNumber: "sayı olmalıdır",
        bulkUploadfailed: "Toplu yükleme başarısız oldu",
        importFromExcel: "Excel'den İçe Aktar",
        generating: "Oluşturuluyor...",
        downloadTemplate: "Şablonu İndir",
        uploading: "Yükleniyor...",
        done: "Tamamlandı",
        requiredField: "{field} zorunludur",
        bulkUpload: "Toplu Yükleme",
        duplicateSku: "Yinelenen SKU bulundu",
        uploadedSuccessfully: "Tüm ürünler başarıyla yüklendi!",
        uploadCompleteIssues: "Yükleme sorunlarla tamamlandı",
        uploaded_products: "{count} ürün yüklendi.",
        failed_products: "{count} başarısız oldu.",
        failed_items: "Başarısız öğeler:"
    },
    ProductForm: {
        barcodeQuantity: "Barkod Miktarını Girin",
        baseUnit: "Temel Birim (Ana)",
        addSecondaryUnit: "İkincil Birim Eklemek İstiyor musunuz?",
        selectUnit: "Birim Seç",
        subUnitDetails: "Alt Birim Detayları",
        subUnit: "Alt Birim",
        selectSubUnit: "Alt Birim Seç",
        conversionRate: "Dönüşüm Oranı",
        exampleLogic: "Örnek mantık:",
        example: "Kalemleri kutu halinde satıyorsanız, Temel Birim olarak Kutu seçin ve Alt Birim olarak adet ekleyin, dönüşüm oranı 50 olsun. Yani 1 Kutu = 50 adet anlamına gelir.",
        basePrice: "Temel Fiyat",
    },
    barcode: {
        settings: 'Barkod Ayarları',
        labelSize: 'Etiket boyutu',
        customSize: 'Özel boyut...',
        widthMm: 'Genişlik (mm)',
        heightMm: 'Yükseklik (mm)',
        showPrice: 'Satış fiyatını etikette göster',
        noPrices: 'Bu ürün için satış fiyatı yapılandırılmadı.',
        preview: 'Önizleme',
        generate: 'Oluştur',
        label: 'etiket',
        singlePage: 'Tek Sayfa',
        downloadOptions: 'İndirme Seçenekleri',
        chooseLayout: 'Barkodlar için düzen seçin',
        allInSinglePage: 'Tüm barkodları tek sayfaya ekle.',
        allInA4Grid: 'Hepsi Tek Sayfada',
        allInA4GridSub: 'Tüm barkodları A4 ızgarasına yerleştirir',
        onePerPage: 'Sayfa Başına Bir',
        onePerPageSub: 'Her barkod kendi etiket sayfasında'
    },

    Discount: {
        overallDiscount: "Genel İndirim",
        final: 'Son',
        balanceDue: "Kalan Tutar",
        tax: "Vergi",
    },
    TransferItem: {
        transferItem: 'Ürün Transferi',
        Date: 'Tarih',
        Reason: 'Sebep',
        enterReason: "Sebep Girin",
        Name: 'Ad',
        QuantityTransfered: 'Transfer Edilen Miktar',
        SWarehouse: 'Kaynak Depo',
        SelectSWarehouse: 'Kaynak Depo Seç',
        DWarehouse: 'Hedef Depo',
        SelectDWarehouse: 'Hedef Depo Seç',
        CreatedBy: 'Oluşturan',
        CreatedTime: 'Oluşturulma Saati',
        UpdatedTime: 'Güncellenme Saati',
        NoOrderFound: 'Sipariş Bulunamadı',
        New: 'Yeni',
        WarehouseItemTransfer: 'Depo Ürün Transferi',
        TotalTransfers: "Toplam Transfer",
        EnterReason: 'Sebep Girin',
        ItemDetails: 'Ürün Detayları',
        CurrentAvailable: 'Mevcut Durum',
        TransferQty: 'Transfer Miktarı',
        SStock: 'Kaynak Stok',
        DStock: 'Hedef Stok',
        addDescription: "Ürününüz için açıklama ekleyin",
        selectVariant: "Varyant seçin",
        addNewRow: "Yeni satır ekle",
        typeOrSelectItem: "Aramak için yazın",
        scrollToLoadMore: "Daha fazla yüklemek için kaydırın",
        noProductsFound: "Ürün bulunamadı",
        selectWarehouse: "Depo seçin"
    },
    Sku: {
        searchSelectProduct: "Ürün Ara/Seç",
        searchSelectSku: "SKU Ara/Seç",
        noSkuFound: "SKU bulunamadı"
    },
    HistoryPage: {
        addFilter: "Filtre Ekle",
        filtersActive: "Tüm filtreler aktif",
        noProducts: "Ürün yok",
        download: "İndir",
        recentlyUpdated: "Son Güncellenenler",
    },
    StockPage: {
        challanNumber: "İrsaliye Numarası",
        subTotal: "Ara Toplam",
        totalTaxes: "Toplamlar & Vergiler",
        taxInclusive: "Vergi Dahil",
        discountedValue: "İndirimli Değer",
        taxValue: "Vergi Değeri",
        totalAmount: "Toplam Tutar",
        close: "Kapat",
        addTax: "Vergi Ekle",
        label: "Etiket",
        enterLabel: "Etiket Girin",
        taxRate: "Vergi Oranı",
        enterTaxRate: "Vergi oranını girin",
        selectTaxRate: "Vergi Oranı Seç",
        addNewTax: "Yeni vergi oranı ekle",
        discountProducts: "İndirimli Değer (Ürünler)",
        taxProducts: "Vergi Değeri (Ürünler)",
        clickAddPayment: "Ödeme eklemek için tıklayın",
        paidGreaterPayable: "Ödenen tutar, ödenecek tutardan büyük olamaz",
        vendorCompulsory: 'Ödeme kaydetmek için tedarikçi zorunludur',
        customerCompulsory: "Ödemeyi kaydetmek için müşteri gereklidir",
        updateInvoiceFormat: "Fatura Formatını Güncelle",
        updateChallanFormat: "İrsaliye Formatını Güncelle",
        addPrefix: "Ön Ek Ekle",
        prefix: "Ön Ek"
    },
    EditHistoryPage: {
        search_by_notes: "Notlara Göre Ara",
        alertMessage: "Bu değişiklik sadece geçmişe kaydedildi ve mevcut ürün stoğunu etkilemez.",
        paymentDetails: "Ödeme Detayları",
        units: "Birimler",
        customLabels: "Özel Etiketler",
        value: "Değer",
        Order_Info: "Sipariş Bilgisi",
        percentage: "Yüzde",
        Stock_updates_on_submit: "Gönderildiğinde stok güncellenir",
        Summary: "Özet"
    },
    historyCard: {
        paid: "ÖDENDİ",
        partiallyPaid: "KISMEN ÖDENDİ",
        billDate: "Fatura Tarihi",
        productDetails: "Ürün Detayları",
        paymentsHistory: "Ödeme Geçmişi",
        updatePayment: "Ödemeyi Güncelle",
        discounts: "İndirimler",
        inclusive: "(dhl.)",
        discountOverall: "İndirimli Değer (Genel)",
        dueAmount: "Kalan Tutar",
        enterPaid: "Ödenen Tutarı Girin",
        enterReference: "Referans Girin",
        enterNote: "Not Girin",
        enterInvoice: "Fatura Girin",
        enterChallan: "İrsaliye Girin",
        edit: "Düzenlendi"
    },
    printInvoice: {
        billTo: "Fatura Alıcısı",
        ref: "Ref No.",
        mode: "Ödeme Şekli",
        date: "Tarih",
        amount: "Tutar",
        totalPaid: "Toplam Ödenen",
        noImage: "Resim Yok"
    },
    Contact: {
        supplier_required: "Stok girişi için tedarikçi zorunludur",
        customer_required: "Stok çıkışı için müşteri zorunludur",
        key: "Anahtar",
        editHistory: "Geçmişi Düzenle",
        loading: "Yükleniyor..."
    },
    AW: {
        availablewarehouse: "Mevcut Depo",
        visibilityManagement: 'Görünürlük Yönetimi',
        availablewarehouses: "Mevcut Depolar",
        Active: "Aktif",
        LWarehouse: "Depolar yükleniyor...",
        NWForthisProduct: "Bu ürün için depo bulunamadı.",
        of: " / ",
        WarehouseAvailabilty: "Depo Kullanılabilirliği",
    },
    Currency: {
        searchCurrency: "Para Birimi Ara...",
        addCurrency: "Para Birimi Ekle",
        addNewCurrency: "Yeni Para Birimi Ekle",
        editCurrency: "Para Birimini Düzenle",
        currencySymbol: "Para Birimi Sembolü",
        currencyName: "Para Birimi Adı",
        enterCurrencySymbol: "Para Birimi Sembolü Girin",
        enterCurrencyName: "Para Birimi Adı Girin"
    },
    NewReportLang: {
        DM: "Günlük Hareket",
        WR: "Depo Raporu",
        PDM: "Ürün Günlük Hareketi",
        TBP: "Toplam Satın Alma Fiyatı",
        TPQ: "Toplam Ürün Miktarı",
        TP: "Toplam Ürünler",
        CS: "Mevcut Stok",
        IV: "Envanter Değeri",
        DA: "Günlük Ortalama",
        TSI: "Toplam Stok Girişi",
        TSO: "Toplam Stok Çıkışı",
        TOR: "Devir Hızı",
        Tv: "Toplam Değer",
        AST: "Aktif SKU İzleme",
        UT: "İzlenen Birimler",
        SL: "Stok Seviyesi",
        Value: "Değer",
        IO: "GİRİŞ/ÇIKIŞ",
        T: "Devir",
        unitsD: "Birim/Gün",
        Sort: "Sırala",
        Sort_by: "Şuna göre sırala",
        Units_available: "Kullanılabilir Birimler",
        Units_unavailable: "Kullanım Dışı Birimler",
        Current_assets: "Dönen Varlıklar",
        Search: "Ara",
        available: "Mevcut",
        assigned: "Atanmış",
        AYSWD: "Silmek istediğinizden emin misiniz?",
        PTS: "Depo başarıyla transfer edildi",
        AUS: "Varlıklar başarıyla güncellendi",
        ACS: "Varlıklar başarıyla oluşturuldu",
        VSP: "Satış fiyatını görüntüle",
        HUS: "Geçmiş başarıyla güncellendi",
    },
    ReplacementReturn: {
        selectProduct: "Lütfen bir ürün seçin",
        selectReplacementProduct: "En az bir yedek ürün seçin",
        validQuantity: "Geçerli bir iade miktarı girin",
        replacedSuccessfully: "Ürün başarıyla değiştirildi",
        returnSuccessfully: "Ürün başarıyla iade edildi",
        failedProcess: "İşlem başarısız. Lütfen tekrar deneyin.",
        return: "İade",
        replace: "Değiştir",
        typeSelectProduct: "Ürün yazın veya seçin...",
        returnQuantity: "İade Miktarı",
        enterQuantity: "Miktar Girin",
        replacementDate: "Değişim Tarihi",
        returnDate: "İade Tarihi",
        chooseCustomer: "Müşteri Seç",
        additionalNotes: "Ek notlar ekleyin...",
        replacementProducts: "Yedek Ürünler",
        addProducts: "Daha Fazla Ürün Ekle",
        tapSelect: "Mevcut ürünlerden seçmek için dokunun",
        currently: "Şu anda",
        item: "ürün",
        items: "ürün",
        selected: "seçildi",
        selectedItems: "Seçilen ürünler",
        hideDetails: "Daha fazla detayı gizle",
        showDetails: "Daha fazla detay göster",
        product: "ürün",
        priceLevel: "Fiyat seviyesi seç",
        customPrice: "Özel fiyat gir",
        noReplaceHistory: "Değişim geçmişi bulunamadı",
        replaceReturn: "Değiştir ve İade Et",
        replaceReturnHistory: "Değişim ve İade Geçmişi"
    },
    OtherComponent: {
        mfgHistoryTitle: "Üretim Geçmişi",
        mfgHistoryDesc: "Üretilen stok ürünlerini takip et",
        dailyOperation: "Günlük Operasyonlar",
        freqUsed: "Kayıtları hızlı güncellemek için sık kullanılan eylemler",
        manageCategory: "Kategorileri Yönet",
        organizeCaterory: "Ürün, gider ve varlık kategorilerini düzenleyin ve yönetin",
        businessRecord: "İş Kayıtları",
        organizeRecord: "İş kayıtlarınızı düzenleyin ve yönetin",
        trackHistory: "Geçmişi Takip Et",
        completeTracking: "Denetim ve takip için tam geçmiş",
        Verifyinventorycount: "Envanter sayımını doğrula",
        Exchangerates: "Döviz kurları",
        Productiontracking: "Üretim takibi",
        Fixedassetregister: "Sabit kıymet kayıtları",
        Storagelocations: "Depolama konumları",
        warehouseAvailability: 'Depo düzeyinde ürün mevcudiyeti',
        Logreviewspend: "Harcamaları kaydet ve incele",
        Productgroupings: "Ürün gruplandırmaları",
        Classifyexpenditures: "Harcamaları sınıflandır",
        Assetclassification: "Varlık sınıflandırması",
        Manageexchanges: "Döviz işlemlerini yönet",
        Returnauditlog: "İade denetim kaydı",
        Interlocationmoves: "Konumlar arası hareketler",
        Manageoperationscategoriesrecordsandhistory: "Operasyonları, kategorileri, kayıtları ve geçmişi yönet"
    },
    no_permission_dialog: {
        title: 'İzin Yok',
        historyDescription: "İşlem Geçmişini görüntüleme izniniz yok. Lütfen yöneticinize başvurun.",
        replacementHistoryDescription: "Değişim ve İade Geçmişini görüntüleme izniniz yok. Lütfen yöneticinize başvurun.",
        transferHistoryDescription: "Depo Transfer Geçmişini görüntüleme izniniz yok. Lütfen yöneticinize başvurun."
    },
    OthersHistory: {
        title: "Geçmişi Yönet",
        transferHistory: "Transfer Geçmişini Yönet",
        transactionHistory: "İşlem Geçmişini Yönet",
        replacementHistory: "Değişim ve İade Geçmişini Yönet"
    },
    catalog: {
        allCategories: "All",
        category: "Category",
        purchaseDescription: "İşletme tarafından paylaşılan ürünlere göz atın ve satın alın.",
        description: "İşletme tarafından paylaşılan ürünlere göz atın.",
        productsAvailable: "Mevcut ürünler",
        noImageAvailable: "Görsel mevcut değil",
        productDetails: "Ürün detayları",
        inStock: "stokta var",
        availableVariants: "Mevcut seçenekler",
        options: "seçenekler",
        orders: "Siparişler"
        ,
        searchProducts: "Ürün ara...",
        noProductsFound: "Ürün bulunamadı",
        tryDifferentKeyword: "Farklı bir anahtar kelime ile arayın",
        variants: "Varyantlar",
        stock: "Stok",
        cart: "Sepet",
        products: "Ürünler",
        viewCart: "Sepeti Görüntüle",
        backToProducts: "Ürünlere Dön",
        yourCart: "Sepetiniz",
        clear: "Temizle",
        cartEmpty: "Sepetiniz boş",
        cartEmptyDesc: "Kataloğu inceleyin ve sipariş etmek istediğiniz ürünleri ekleyin.",
        browseProducts: "Ürünleri İncele",
        selectedItems: "Seçilen Ürünler",
        itemInCart: "ürün sepette",
        itemsInCart: "ürün sepette",
        customerDeliveryDetails: "Müşteri ve Teslimat Bilgileri",
        fullName: "Ad Soyad",
        enterFullName: "Adınızı ve soyadınızı girin",
        deliveryAddress: "Teslimat Adresi",
        addressPlaceholder: "Sokak, bina, şehir, posta kodu...",
        orderNote: "Sipariş Notu (İsteğe Bağlı)",
        orderNotePlaceholder: "Özel talimatlar veya teslimat notları...",
        paymentMode: "Ödeme Yöntemi",
        subtotal: "Ara Toplam",
        items: "ürün",
        totalAmount: "Toplam Tutar",
        orderOnWhatsApp: "WhatsApp ile Sipariş Ver 📲",
        orderPlaced: "Sipariş Başarıyla Verildi! 🎉",
        orderPlacedDesc: "Siparişiniz kaydedildi ve WhatsApp açıldı.",
        continueShopping: "Alışverişe Devam 🛍️",
        cartEmptyTitle: "Sepet Boş",
        cartEmptyToast: "Lütfen ödeme yapmadan önce ürün ekleyin.",
        incompleteTitle: "Eksik Bilgiler",
        incompleteToast: "Lütfen sipariş vermeden önce tüm zorunlu alanları doldurun.",
        nameRequired: "Ad soyad zorunludur",
        addressRequired: "Teslimat adresi zorunludur",
        catalogUnavailable: "Katalog Şu Anda Kullanılamıyor",
        catalogUnavailableDesc: "Bu katalog şu anda aktif değil. İşletme ile iletişime geçin.",
        invalidCatalogLink: "Geçersiz Katalog Bağlantısı 🚫",
        invalidCatalogDesc: "Bu katalog sayfasında gerekli bilgiler eksik.",
        missing: "Eksik",
        catalogSlug: "Katalog Kodu",
        goBackHome: "Ana Sayfaya Dön",
        inventoryManagement: "Envanter Yönetimi ve Faturalama 🚀 Simply",
        enter: "Girin",
        select: "Seçin",
        // Catalog Order translations
        catalogOrders: 'Katalog Siparişleri',
        pending: 'Beklemede',
        converted: 'Dönüştürüldü',
        cancelled: 'İptal edildi',
        totalRevenue: 'Toplam Değer',
        totalCatalogOrders: 'Toplam Çevrimiçi Sipariş',
        convertToSalesOrder: 'Satış Siparişine Dönüştür',
        date: 'Tarih',
        status: 'Durum',
        action: 'İşlem',
        searchOrders: 'Müşteri veya telefon ara...',
        noMatchingOrders: 'Eşleşen sipariş bulunamadı',
        noStatusOrders: '{status} sipariş bulunamadı',
        tryDifferentSearch: 'Farklı bir müşteri adı veya telefon numarasıyla aramayı deneyin.',
        noOrdersWithStatus: 'Şu anda {status} durumunda sipariş bulunmamaktadır.',
        noOrdersYet: 'Henüz Katalog Siparişi Yok',
        noOrdersDescription: 'Çevrimiçi katalogunuzdan verilen siparişler burada görünecektir.',
        guestCustomer: 'Misafir Müşteri',
        item: 'Ürün',
        moreItems: '+{count} daha',
        viewDetails: 'Detayları Gör',
        viewSalesOrder: 'Satış Siparişini Gör',
        cancelOrder: 'Siparişi İptal Et',
        confirmCancelTitle: 'Katalog siparişi iptal edilsin mi?',
        confirmCancelOrder: 'Bu siparişi iptal etmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
        keepOrder: 'Hayır, Siparişi Koru',
        confirmCancelAction: 'Evet, Siparişi İptal Et',
        orderNotFound: 'Katalog Siparişi Bulunamadı',
        orderNotFoundDescription: 'Bu sipariş bulunamadı veya görüntüleme izniniz olmayabilir.',
        backToCatalogOrders: 'Katalog Siparişlerine Dön',
        placedOn: 'Sipariş tarihi',
        totalItems: 'Toplam Ürün',
        orderedProducts: 'Sipariş Edilen Ürünler',
        itemDetails: 'Ürün Detayları',
        quantity: 'Adet',
        unitPrice: 'Birim Fiyat',
        total: 'Toplam',
        variant: 'Varyant',
        customerInformation: 'Müşteri Bilgileri',
        additionalFields: 'Ek Alanlar',
        fields: 'alan',
    },
    stockNew: {
        Npay: "Henüz ürün eklenmedi",
        emptydesc: "Kataloğunuzdan bir ürün seçin ve stoğu kaydetmek için gelen miktarı girin.",
        tipText: "İpucu: Excel dosyasını da yükleyebilirsiniz",
        OT: "Sipariş Toplamı",
        Collapse: "Daralt"
    },
    deleteBulk: {
        Bulkoperation: "Toplu İşlem",
        Applyproducts: "Birden fazla ürüne işlem uygula",
        Bulkupload: "Toplu Yükleme",
        ImportCSVfile: "Excel veya CSV dosyası ile ürünleri içe aktar",
        or: "veya",
        Bulkdelete: "Toplu Silme",
        Permanentlyallproducts: "Tüm ürünleri kalıcı olarak kaldır",
        IrrText: "Toplu silme geri alınamaz. Gerekirse önce yedek dışa aktarın.",
        SeP: "Seçili Ürünler",
        sP: "Ürün Seç",
        DA: "Tümünü Sil",
        DP: "Ürünleri Sil",
        sL: "Tümünü Seç",
        ASDE: "hariç tüm ürünleri silmek istediğinizden emin misiniz",
        ASDAllP: "Tüm ürünleri silmek istediğinizden emin misiniz?",
        ASD: "silmek istediğinizden emin misiniz",
        products: "ürün",
        TACBU: "Bu işlem geri alınamaz.",
        LP: "Ürünler yükleniyor...",
        FM: "Daha fazla getiriliyor...",
        NPF: "Ürün bulunamadı.",
        LMP: "Daha fazla ürün yükleniyor..."
    },
    NewVariantModal: {
        Definevariantsassign: "Varyantları tanımla ve miktar ata",
        Nothingallocated: "Hiçbir şey atanmadı",
        Overallocated: "Aşırı atanmış",
        Fullyallocated: "Tamamen atanmış",
        Overby: "Aşırı",
        Allvariantsneedaname: "Tüm varyantların isme ihtiyacı var.",
        Reducequantities: "Miktarları azalt.",
        Overallocatedby: "Aşırı atanmış",
        Quantitiesmustmatchthetotalavailability: "Miktarlar toplam kullanılabilirlikle eşleşmeli.",
        Allocatequantitiesacrosswarehouses: "Miktarları depolar arasında ata",
        Notfullydistributed: "Tamamen dağıtılmadı:",
        remaining: "kalan",
        Qty: "Miktar",
        Inactive: "Etkin Değil",
        left: "kalan"
    },
    ProductFormNew: {
        BasicInfo: "Temel Bilgiler",
        ProductImage: "Ürün Görseli",
        Images: "Görseller",
        Pricing: "Fiyatlandırma",
        Everypriceneedsbothalabelandanamount: "Her fiyatın hem etiketi hem de tutarı olmalıdır",
        AddalabellikeWholesaleorRetailtoidentifythisprice: '"Toptan" veya "Perakende" gibi bir etiket ekleyerek bu fiyatı tanımlayın',
        AddMultiplePrice: "Birden Fazla Fiyat Ekle",
        NoPhotosLetAiFind: "Fotoğraf yok mu? AI'nın ürün görsellerini bulmasına izin verin",
        AddProductImagesTitle: "Ürün Görselleri Ekle",
        ChooseHowToAddPhotos: "Bu ürün için nasıl fotoğraf eklemek istediğinizi seçin:",
        SearchWithAi: "AI ile Ara",
        SearchWithAiDesc: "AI kullanarak ürün görsellerini otomatik olarak bulun ve seçin",
        FilesFileExplorer: "Dosyalar (Dosya Gezgini)",
        FilesFileExplorerDesc: "Görselleri doğrudan bilgisayarınızdan seçin",
        AiProductImageFinder: "AI Ürün Görsel Bulucu",
        AiProductImageFinderDesc: "Ürününüz için görseller arayın ve seçin",
        TypeProductNamePlaceholder: "Ürün adını yazın...",
        SearchForYourProduct: "Ürününüzü arayın",
        SearchForYourProductHint: `Bir marka veya ürün adı deneyin, örn. "Kirkland Minoxidil"`,
        ImagesSelected: "görsel seçildi",
        AddSelected: "Seçilenleri Ekle"
    },
    AttributeNewCustom: {
        Defineanewcustomfield: "Yeni özel alan tanımla",
        AttributeName: "Özellik Adı",
        DataType: "Veri Türü",
        Noattributesfound: "Özellik bulunamadı",
        ManageAttributes: "Özellikleri Yönet",
        Editordeleteexistingattributes: "Mevcut özellikleri düzenle veya sil",
        UpdateAttribute: "Özelliği Güncelle",
        Saving: "Kaydediliyor..."
    },
    NewExpenses: {
        Noexpensesyet: "Henüz harcama yok",
        Addyourfirstexpensetostarttrackingyourspending: "Harcamalarınızı takip etmeye başlamak için ilk harcamanızı ekleyin.",
        TOTALEXPENSES: "TOPLAM HARCAMALAR",
        ENTRIES: "GİRİŞLER",
        BYCATEGORY: "KATEGORİYE GÖRE",
        Nocategoriestodisplay: "Gösterilecek kategori yok",
        DateanfTime: "Tarih ve Saat"
    },
    PurchaseSales: {
        CancelOrder: "Siparişi iptal et",
        ReopenOrder: "Siparişi yeniden aç",
        Reopen: "Yeniden aç",
        ConfirmCancelOrder: "Bu siparişi iptal etmek istediğinizden emin misiniz?",
        ConfirmReopenOrder: "Bu siparişi yeniden açmak istediğinizden emin misiniz?",
        OrderCancelledSuccessfully: "Sipariş başarıyla iptal edildi.",
        OrderReopenedSuccessfully: "Sipariş başarıyla yeniden açıldı.",
        CancelledBy: "İptal eden",
        Cancelled: "İptal edildi",
        ConvertPriceBasedOnUnitConversion: "Birim Dönüşümüne Göre Fiyat Dönüştür",
        MarkPaymentAsPending: "Ödemeyi beklemede olarak işaretle",
        PendingReceivableDesc: "Tutar alacak olarak kaydedildi. Ödeme alındığında kaydedin.",
        PendingPayableDesc: "Tutar borç olarak kaydedildi. Ödeme yapıldığında kaydedin.",
        SelectCustomerFirst: "Önce müşteri seçin",
        SelectSupplierFirst: "Önce tedarikçi seçin",
        SelectItemsFirst: "Lütfen önce en az bir ürün seçin",
        PaymentMarkedPendingDesc: "Ödeme beklemede olarak işaretlendi. Şimdi ödeme kaydetmek için 'Ödemeyi beklemede olarak işaretle' seçimini kaldırın.",
        SelectCustomerAndItemFirst: "Lütfen önce bir müşteri ve en az bir ürün seçin",
        SelectSupplierAndItemFirst: "Lütfen önce bir tedarikçi ve en az bir ürün seçin",
        SelectCustomerProductFirst: "Önce müşteri ve ürün seçin",
        SelectSupplierProductFirst: "Önce tedarikçi ve ürün seçin",
        Receivables: "Alacaklar",
        Payables: "Borçlar",
        AccessDenied: "Erişim Engellendi",
        YouDonthaeP: "Bu sayfayı görüntüleme izniniz yok. Bunun bir hata olduğunu düşünüyorsanız lütfen yöneticinizle iletişime geçin.",
        purchase: "Satın Alma",
        sales: "Satış",
        Areyousureyouwantto: "Emin misiniz",
        Thisactionwillupdateitsstatus: "Bu işlem durumunu güncelleyecek.",
        ReasonOPtional: "Sebep (İsteğe bağlı)",
        Enterareasonfor: "Şunun için bir sebep girin",
        optionalDot: "(isteğe bağlı)...",
        Reject: "Reddet",
        ConfirmOrder: "Siparişi Onayla",
        RejectOrder: "Siparişi Reddet",
        Previous: "Önceki",
        First: "İlk",
        Order: "Sipariş",
        Items: "Ürünler",
        Memo: "Not",
        SelectDateRange: "Tarih Aralığı Seç",
        List: "Liste",
        Board: "Pano",
        View: "Görünüm",
        CreateSalesOrder: "Satış Siparişi Oluştur",
        CreatePurchaseOrder: "Satın Alma Siparişi Oluştur",
        successfully: "başarıyla",
        ManageAttachments: "Ekleri Yönet",
        Stockoutitemsimmediatelyaftersaving: "Kaydettikten hemen sonra stoktan çıkar.",
        Stockinitemsimmediatelyaftersavingthisorder: "Bu siparişi kaydettikten hemen sonra stoğa ekle.",
        ViewAttachments: "Ekleri Görüntüle",
        MemoAttachments: "Not ve Ekler",
        ReceivedDate: "Alınma Tarihi",
        ShippedDate: "Gönderim Tarihi",
        OrderDate: "Sipariş Tarihi",
        OrderDetails: "Sipariş Detayları",
        Subtotal: "Ara Toplam",
        OrderSummary: "Sipariş Özeti",
        AddItem: "Ürün Ekle",
        NewSalesOrder: "Yeni Satış Siparişi",
        NewPurchaseOrder: "Yeni Satın Alma Siparişi",
        Createandmanageyour: "Oluştur ve yönet",
        orders: "siparişlerinizi",
        Removeitem: "Ürünü Kaldır",
        UnitPrice: "Birim Fiyat",
        PurchaseOrder: "Satın Alma Siparişi",
        SalesOrder: "Satış Siparişi",
        PurchaseInvoice: "Satın Alma Faturası",
        SalesInvoice: "Satış Faturası",
        PurchaseOrdernotfound: "Satın Alma Siparişi bulunamadı",
        Approve: "Onayla",
        MarkasShipped: "Gönderildi olarak işaretle",
        MarkasReceived: "Alındı olarak işaretle",
        Marking: "İşaretleniyor...",
        PartiallyShip: "Kısmi Gönderim",
        PartiallyReceive: "Kısmi Alım",
        Deleting: "Siliniyor...",
        Transaction: "İşlem",
        Details: "Detaylar",
        Item: "Ürün",
        Received: "Alındı",
        Shipped: "Gönderildi",
        Ordered: "Sipariş Edildi",
        units: "adet",
        Overalldiscount: "Genel İndirim",
        Transactions: "İşlemler",
        Notransactionsfound: "İşlem bulunamadı",
        OrderedQty: "Sipariş Edilen Miktar",
        Totalqty: "Toplam Miktar",
        StockingOut: "Stoktan çıkarılıyor...",
        StockingIn: "Stoğa ekleniyor...",
        thiorderUpdateStuau: "bu sipariş? Bu işlem durumunu güncelleyecek.",
        TransactionDetails: "İşlem Detayları",
        Fetchingtransactiondetails: "İşlem detayları getiriliyor...",
        Nodetailsfoundforthistransaction: "Bu işlem için detay bulunamadı.",
        TotalBreakDown: "Toplam Kırılım",
        ChangeAmount: "Para Üstü",
        Attachments: "Ekler",
        PoNumber: "Satın Alma Sipariş No",
        SoNumber: "Satış Sipariş No",
        partner: "İş Ortağı",
        EditPurchase: "Satın Almayı Düzenle",
        EditSales: "Satışı Düzenle",
        PurchaseOrderDetails: "Satın Alma Siparişi Detayları",
        SalesOrderDetails: "Satış Siparişi Detayları",
        OrderType: "Sipariş Türü",
        SelectOrderType: "Sipariş Türü Seçin",
        OrderTypePrepaid: "Ön Ödemeli",
        OrderTypeCOD: "Kapıda Ödeme",
        OrderTypePayLater: "Sonra Öde",
        OrderTypePartialPayment: "Kısmi Ödeme",
        OrderTypeSubscription: "Abonelik",
        viewAvailabilty: 'Uygunluğu Görüntüle',
        NotReceived: "Alınmadı",
        NotShipped: "Gönderilmedi",
        PartiallyReceived: "Kısmen Alındı",
        PartiallyShipped: "Kısmen Gönderildi",
    },
    PriceReference: {
        HighPrice: "Yüksek Fiyat",
        LowPrice: "Düşük Fiyat",
        LastPrice: "Son Fiyat",
        LastPurchasePrice: "Son Satın Alma Fiyatı",
        Nopricerecordsfound: "Fiyat kaydı bulunamadı",
        BuyingPriceReference: "Alış Fiyatı Referansı",
        SellingPriceReference: "Satış Fiyatı Referansı",
        Viewstockinpricesfortheselectedvendorandproduct: "Seçilen tedarikçi ve ürün için stok giriş fiyatlarını görüntüle",
        Viewstockoutpricesfortheselectedcustomerandproduct: "Seçilen müşteri ve ürün için stok çıkış fiyatlarını görüntüle"
    },
    SubscriptionLocale: {
        premiumPlan: "Premium Plan",
        heading: "İş Kararları Alın",
        headingHighlight: "Verilere Dayalı",
        subtitle: "İş analitiğinizin tam gücünü açığa çıkarın — sınır yok, taviz yok.",
        choosePlan: "Planınızı seçin",
        monthly: "Aylık",
        annual: "Yıllık",
        oneTime: "Tek Seferlik (Aylık)",
        perMonth: "aylık",
        perYear: "yıllık",
        bestValue: "En İyi Değer",
        continueWith: "Devam et",
        perMonthShort: "ay",
        perYearShort: "yıl",
        troubleWithSubscription: "Abonelikte sorun mu var?",
        contactUs: "Bize Ulaşın",
        paymentNotReady: "Ödeme hazır değil",
        checkoutError: "ÖDEME HATASI",
        pricePreviewError: "FİYAT ÖNİZLEME HATASI",
        subNotAvailable: "Abonelik mevcut değil",
        subNotAvailableDesc: "Web abonelikleri şu anda ülkenizde mevcut değil. Lütfen mobil uygulamamız üzerinden abone olun veya yardım için bizimle iletişime geçin."
    },
    SubscriptionLocale2: {
        GoPro: "Pro'ya Geç",
        Makesmarterdecisionsbackedbyrealbusinessdata: "Gerçek iş verileriyle desteklenen daha akıllı kararlar alın",
        ExploreProPlans: "Pro Planları Keşfet"
    },
    emptyWarehouseState: {
        tips: [
            "Farklı fiziksel konumlar için birden fazla depo sahibi olabilirsiniz",
            "Her ürün stoğu her depo için bağımsız olarak takip eder",
            '"Depo Transferi"ni kullanarak stokları konumlar arasında taşıyın'
        ],
        NoWarehousesConfigured: "Hiç Depo Yapılandırılmadı",
        desc: "Önce depolarınızı ekleyin (birden fazla varsa), ardından ürünleri ekleyin ve stok hareketlerini kaydedin.",
        WarehouseSetupTips: "Depo Kurulum İpuçları",
        Noproductselected: "Ürün seçilmedi",
        Selectaproductfromthelefttoviewlowstockdetails: "Düşük stok detaylarını görmek için soldan bir ürün seçin.",
        Chooseaproductfromthelist: "Listeden bir ürün seçin",
        SelectProduct: "Ürün Seç",
        SetQuantity: "Miktar Belirle",
        Showing: "Gösteriliyor",
        products: "ürün",
        Continue: "Devam Et",
        SaveSafetyStock: "Güvenlik Stoğunu Kaydet",
        SafetyStockSaved: "Güvenlik Stoğu Kaydedildi!",
        hasbeensetto: "olarak ayarlandı",
        AddAnother: "Başka Ekle",
        Chooseaproduct: "Bir ürün seç",
        Step: "Adım",
        of: "/",
        Setsafetyquantity: "Güvenlik miktarını ayarla",
        Complete: "Tamamlandı",
        SafetyStockQuantity: "Güvenlik Stoğu Miktarı",
        Minimumunitsdropsbelowthisnumber: "Stokta her zaman tutulması gereken minimum birim sayısı. Stok bu sayının altına düştüğünde uyarı tetiklenir.",
        NewSafetyStock: "Yeni Güvenlik Stoğu",
        SafetyNow: "Mevcut Güvenlik",
        SettingTo: "Ayarlanıyor",
        Change: "Değiştir",
        sell: "satış",
        cost: "maliyet",
        BulUD: "Toplu Yükleme/Silme"
    },
    SimplyLoginUI: {
        sslEncryption: "256-bit SSL Şifreleme",
        dataPrivate: "Verileriniz %100 özeldir",
        worksOnDevices: "Android ve iPhone'da çalışır",
        realTimeSync: "Tüm cihazlarda gerçek zamanlı senkronizasyon",
        cloudBackup: "Otomatik bulut yedekleme",
        availableOn: "Web, Android ve iOS'ta mevcut",
        tagline: "Envanteriniz,",
        taglineEm: "güzelce basit.",
        subtitle: "Stok yönetmek, satışları takip etmek ve işinizi ilerletmek için giriş yapın — hepsi tek bir yerde.",
        feature1Title: "Gerçek zamanlı stok takibi",
        feature1Desc: "Her depoda ne olduğunu tam olarak bilin — her zaman güncel.",
        feature2Title: "Satış ve satın alma siparişleri",
        feature2Desc: "Faturalar oluşturun, tedarikçileri yönetin ve her işlemi takip edin.",
        feature3Title: "Akıllı raporlar",
        feature3Desc: "Finans, stok ve günlük hareket raporları bir bakışta.",
        feature4Title: "Tüm cihazlarda gerçek zamanlı senkronizasyon",
        feature4Desc: "Telefondaki değişiklikler web'de anında görünür — ve tersi de.",
        rating1: "Değerlendirme",
        rating2: "4.9/5",
        rating3: "10.000 toptan satış işletmesi tarafından",
        brandName: "Simply",
        greeting: "Tekrar merhaba! 👋",
        noPasswordNeeded: "Envanterinize erişmek için giriş yapın — Android, iPhone ve web, hepsi senkronize.",
        badge1: "Stok Yönetimi",
        badge2: "Satış Takibi",
        badge3: "Raporlar",
        trustEncryptedTitle: "Şifrelenmiş",
        trustEncryptedSub: "256-bit SSL",
        trustPrivateTitle: "Özel",
        trustPrivateSub: "Sadece sizin veriniz",
        trustBackedTitle: "Yedekli",
        trustBackedSub: "Her gün otomatik",
        availableOnLabel: "KULLANILABİLİR",
        platformAndroid: "Android",
        platformIphone: "iPhone",
        platformWeb: "Web",
        syncBadge: "Tüm cihazlar gerçek zamanlı olarak anında senkronize olur",
        securityNote: "%100 güvenli.",
        securityDesc: "Banka seviyesinde şifreleme tüm verilerinizi korur. Sadece adınızı ve e-postanızı okuyoruz — başka hiçbir şey, asla.",
        signingIn: "Giriş yapılıyor…",
        termsPrefix: "Giriş yaparak Simply'nin",
        privacyPolicy: "Gizlilik Politikası",
        and: "ve",
        termsOfService: "Hizmet Şartları",
        google: "Google ile giriş yap"
    },
    BatchLocal: {
        BatchName: "Parti Adı",
        EnterBatchName: "Parti adını girin",
        EnterNotes: "Not girin",
        ExpiredDate: "Son Kullanma Tarihi",
        Selectexpireddate: "Son kullanma tarihini seçin",
        BatchStatus: "Parti Durumu",
        CreatedDate: "Oluşturma Tarihi",
        Areyousureyouwanttodeletethisbatch: "Bu partiyi silmek istediğinizden emin misiniz?",
        Youhavencreatedanybatchforthisproduct: "Bu ürün için henüz herhangi bir parti oluşturmadınız.",
        Createyourfirstbatchtostarttrackingtockbylotexpiry: "Lot ve son kullanma tarihine göre stok takibi yapmaya başlamak için ilk partinizi oluşturun.",
        Nobatchesyet: "Henüz parti yok",
        Whatisbatchmanagement: "Parti yönetimi nedir?",
        Howithelpsyourbusiness: "İşletmenize nasıl yardımcı olur",
        Trackbylotnumber: "Lot numarasına göre takip et",
        Trackbylotnumberdesc: "Stoku üretici partisine göre gruplayın ki her birimin hangi lot'tan geldiğini her zaman bilin.",
        Expirydatecontrol: "Son kullanma tarihi kontrolü",
        Expirydatecontroldesc: "Stok süresi dolmadan önce uyarı alın. Eski partileri önce satın ve israfı otomatik olarak azaltın.",
        Fulltraceability: "Tam izlenebilirlik",
        Fulltraceabilitydesc: "Her işlemde hangi parti kullanıldığını tam olarak görün — denetim ve geri çağırma için mükemmel.",
        Supplierwisestock: "Tedarikçiye göre stok",
        Supplierwisestockdesc: "Aynı ürün için bile farklı tedarikçilerden gelen stokları ayırın. Kaliteyi parti parti karşılaştırın.",
        Createyourfirstbatchbutton: "İlk partinizi oluşturun",
        Nomatchesfound: "Eşleşme bulunamadı",
        NomatchesfounddescBefore: "",
        NomatchesfounddescAfter: " ile eşleşen herhangi bir parti bulunamadı.",
        Clearsearch: "Aramayı temizle",
        Nohistoryfoundthisbatch: "Bu parti için tarihçe bulunamadı",
        ComprehensiveDetails: "Kapsamlı Detaylar",
        History: "Tarihçe",
        InBatch: "Partide",
        Noproductfoundinthisbatch: "Bu partide ürün bulunamadı",
        SelectBatch: "Parti Seç",
        available: "mevcut",
        Searchbatches: "Parti ara...",
        Expires: "Sona eriyor",
        Nobatchesfound: "Hiç parti bulunamadı",
        ManageBatches: "Partileri Yönet",
        Batchmanagement: "Parti Yönetimi",
        Trackstockexpiry: "Stoku parti ve son kullanma tarihine göre takip et",
        Turnoffbatchmanagement: "Parti yönetimini kapatmak istiyor musunuz?",
        Yourgsafe: "Mevcut parti verileriniz güvende kalır.",
        Reenableanytimefrom: "İstediğiniz zaman yeniden etkinleştirebilirsiniz",
        Otherstab: "Diğerler sekmesinden",
        AddBatch: "Parti Ekle",
        Total: "Toplam",
        AssignProduct: "Ürün Ata",
        EditProductAssignment: "Ürün Atamasını Düzenle",
        AssignProducttoBatch: "Ürünü Partiye Ata",
        Updateproductconfiguration: "Ürün yapılandırmasını güncelle",
        Step1of2: "Adım 1/2",
        Step2of2: "Adım 2/2",
        Selectvariantwarehouse: "Varyant ve depo seçin",
        SelectedProduct: "Seçilen Ürün",
        AssignQuantity: "Miktar Ata",
        BatchInfo: "Parti Bilgileri",
        Wecouldnthisproductidentifier: "Bu ürün tanımlayıcısı ile ilişkili herhangi bir parti bulunamadı.",
        NoActiveBatches: "Aktif Parti Yok",
        Endofresults: "Sonuçların Sonu",
        Expiry: "Son Kullanma",
        BatchManagementDescription: "Stoku parti numarası ve son kullanma tarihine göre takip edin. Her stok çıkışında doğru LIFO / FEFO sırasını sağlar — manuel seçime gerek kalmaz.",
        Expiryalerts: "Son Kullanma Uyarıları",
        Autonotifications: "Otomatik Bildirimler",
        LIFOsorting: "LIFO / FEFO Sıralama",
        Smartstockflow: "Akıllı Stok Akışı",
        Perout: "Parti Başına Stok Çıkışı",
        Precisiontracking: "Hassas Takip",
        NeedsReview: "İnceleme gerekiyor",
        Pending: "Beklemede",
        Rejected: "Reddedildi",
        Approved: "Onaylandı",
        WaitingForApproval: "Onay bekleniyor",
        WaitingForApprovalDesc: "Sahibiniz bu partiyi yakında inceleyip onaylayacaktır.",
        BatchRejected: "Parti reddedildi",
        BatchRejectedDesc: "Sahibiniz bu partiyi reddetti.",
        Reason: "Sebep",
        Approve: "Onayla",
        Reject: "Reddet",
        ConfirmApproveTitle: "Partiyi onayla",
        ConfirmRejectTitle: "Partiyi reddet",
        ConfirmApprovalAction: "Bu partiyi {action} istediğinizden emin misiniz? Bu işlem durumunu güncelleyecektir.",
        ReasonOptional: "Sebep (İsteğe bağlı)",
        EnterReasonPlaceholder: "{action} için bir sebep girin (isteğe bağlı)",
        Processing: "İşleniyor...",
        BatchActivatedSuccess: "Parti başarıyla etkinleştirildi",
        BatchDeactivatedSuccess: "Parti başarıyla devre dışı bırakıldı",
        BatchDeletedSuccess: "Parti başarıyla silindi",
        BatchApprovedSuccess: "Parti başarıyla onaylandı",
        BatchRejectedSuccess: "Parti başarıyla reddedildi",
        SearchByBatchName: "Parti adına göre ara...",
        YesTurnOff: "Evet, kapat",
        KeepItOn: "Açık tut"
    },
    CategoryNewL: {
        TotalCategories: "Toplam Kategori",
        lastaddedcategory: "son eklenen kategori",
        acrossalltypes: "tüm türlerde",
        MostRecent: "En Son",
        YesD: "Evet, Sil",
        AllAssociated: "İlişkili tüm ürünler etkilenebilir"
    },
    OverDas: {
        movestockbetweenlocations: "Stokları konumlar arasında taşı",
        no_activity_yet: "Henüz aktivite yok",
        no_activity_sub: "Satışlar, alımlar, stok hareketleri ve iadeler burada gerçek zamanlı olarak görünecek.",
        make_first_sale: "İlk Satışı Yap",
        add_stock: "Stok Ekle",
        all_stock_healthy: "Tüm stok seviyeleri sağlıklı",
        all_stock_healthy_sub: "Hiçbir ürün bitmek üzere değil. Burada uyarı almak için ürünlerde minimum eşik değerleri belirleyin.",
        set_stock_thresholds: "Stok Eşik Değerlerini Ayarla",
        no_warehouses_setup: "Hiçbir depo kurulmadı",
        no_warehouses_setup_sub: "Stoklarınızın nerede depolandığını takip etmek ve konumları yönetmek için bir depo ekleyin.",
        add_first_warehouse: "İlk Depoyu Ekle",
        Customer: "Müşteriler",
        PurchasevsSales: "Alış vs Satış",
        Financialperformancechart: "Finansal performans grafiği",
        QuickActions: "Hızlı İşlemler",
        Frequentlyused: "Sık kullanılanlar",
        Addinventory: "Envanter ekle",
        Dispatchitems: "Ürünleri sevk et",
        Addorder: "Sipariş ekle",
        Newitem: "Yeni ürün",
        Inventoryaccess: "Envanter erişimi",
        Itemsneedingreorder: "Yeniden sipariş edilmesi gereken ürünler",
        Latesttransactions: "Son işlemler",
        Operationalsummary: "Operasyonel özet",
        ViewAll: "Tümünü Gör",
        Manage: "Yönet",
        RecentActivity: "Son Aktiviteler",
        LowStockAlerts: "Düşük Stok Uyarıları",
        Primary: "Birincil",
        TotalWarehouses: "Toplam Depo"
    },
    SerialLocal: {
        ShowOrHideFields: "Alanları göster veya gizle",
        ShowOrHideFieldsDesc: "Yazdırılan faturaya eklemek veya faturadan çıkarmak için aşağıdaki herhangi bir öğeye dokunun. Değişiklikler anında uygulanır.",
        Manufacturesettings: "Üretim ayarları",
        Showbuyingprice: "Alış fiyatı / ürün maliyetini",
        Showadditionalcost: "Ek maliyeti",
        Costbreakdown: "Maliyet dökümü",
        Unitcost: "Birim maliyet",
        Rawmaterialstotal: "Toplam ham madde",
        Confirmentry: "Girişi Onayla",
        SaveSerials: "Seri Numaralarını Kaydet",
        SerialNumber: "Seri Numarası",
        selected: "seçildi",
        added: "eklendi",
        Serialnumbers: "Seri numaraları",
        ResetAll: "Hepsini Sıfırla",
        Wecouldnfindthis: "Bu ürün için kullanılabilir seri numarası bulunamadı.",
        Nounitsfound: "Hiçbir birim bulunamadı",
        Searchingserialnumbers: "Seri numaraları aranıyor...",
        Scanorenterstock: "Yeni stok için seri numaralarını tarayın veya girin",
        Whataserialnumber: "Seri numarası nedir?",
        Auniqueidentifieryourinventorylifecycle: "Birim başına benzersiz tanımlayıcı — envanter yaşam döngüsü boyunca her bir ürünü takip etmenizi sağlar.",
        Trackedstockout: "Takip edilen stok çıkışı",
        Chooseexactlyselected: "Çıkacak seri numaralarını tam olarak seçin. Sadece bu ürün için stoklanmış seriler gösterilir — seçim yaptıktan sonra miktar kilitlenir ",
        SelectSerialstoout: " - Çıkış için seri numaralarını seçin",
        Thisinvoicegeneratedusingwwwsimplstockco: "Bu fatura www.simplstock.co kullanılarak oluşturulmuştur",
        AuthorizedSignature: "Yetkili İmza",
        Invoicesettings: "Fatura ayarları",
        Draw: "Çiz",
        Taptoselectordeselectitems: "Öğeleri seçmek veya seçimini kaldırmak için dokunun",
        Thissignaturewillbeadded: "Bu imza, basılı faturanızın altına eklenecektir.",
        SignatureOptions: "İmza Seçenekleri",
        Upload: "Yükle",
        DrawSignature: "İmza Çiz",
        UploadSignature: "İmza Yükle",
        Clear: "Temizle",
        ShowStaffName: "Personel Adını",
        ShowSKU: "SKU",
        ShowBusinessName: "İşletme Adını",
        ShowProductName: "Ürün Adını",
        ShowBusinessPhoneNumber: "İş telefon numarasını",
        ShowBusinessEmail: "İş e-postasını",
        ShowBusinessAddress: "İş adresini",
        ShowProductImage: "Ürün görselini",
        ShowPaymentDetails: "Ödeme detaylarını",
        ShowCategory: "Kategori",
        ShowVariant: "Varyant",
        ShowWarehouse: "Depo",
        ShowAttributes: "Özellikleri",
        ShowQuantity: "Miktarı",
        ShowDiscount: "İndirimi",
        ShowTax: "Vergiyi",
        ShowPrice: "Fiyatı",
        ShowTotalPrice: "Ürün Toplam Fiyatını",
        ShowExpenses: "Giderleri",
        ShowSignature: "İmzayı",
        ShowNote: "Notu",
        ShowSerialNumber: "Seri Numarasını",
        Invoicesettingsapplied: "Fatura ayarları uygulandı. Değişiklikler için faturayı kontrol edin.",
        EnterSerialNumber: "Seri Numarası Gir",
        showAttachment: "Eki"
    },
    FewLocal: {
        SelectBin: "Bin Seç",
        Live: "Canlı",
        Monitorinventorystocklevels: "Envanter, hareket ve stok seviyelerini izleyin",
        StockControlCentre: "Stok Kontrol Merkezi",
        Nochartdataavailable: "Grafik verisi yok",
        Disabled: "Devre Dışı",
        Enabled: "Etkin"
    },
    Bin: {
        Bin: "Bin",
        Add: "Ekle",
        NoBinsAddedYet: "Henüz bin eklenmedi",
        BinLocationsHelp: "Bin konumları, bu depo içinde stokları tam konumuna göre takip etmenize yardımcı olur — artık arama yapmaya gerek yok.",
        NameThemByPosition: "Konuma göre adlandırın:",
        AddBinLocation: "Bin Konumu Ekle",
        BinLocations: "bin konumları",
        BinNameRequired: "Bin adı zorunludur",
        EditBin: "Bin'i Düzenle",
        AddBin: "Bin Ekle",
        EnterBinName: "Bin Adı",
        EnterBinNamePlaceholder: "Bin adı girin",
        BinStatus: "Bin Durumu",
        BinNotes: "Notlar",
        EnterBinNotesPlaceholder: "Birkaç not ekleyin...",
        ViewInventory: "Envanteri Görüntüle",
        Inventory: "Envanter",
        TrymatchingadifferentSKUname: "Farklı bir SKU veya ad deneyin.",
        Thisbinlocationcurrentlyempty: "Bu bin konumu şu anda boş.",
        Loadingbins: "Binler yükleniyor...",
        bins: "bin",
        ManageBin: "Bin'i Yönet",
        Print: "Yazdır",
        SBin: "Kaynak Bölme",
        DBin: "Hedef Bölme"
    },
    WarehouseExcel: {
        title: "Depoları & Bin Konumlarını Yükle",
        description: "Aşağıdaki adımları izleyerek Excel dosyası ile depoları ve bin konumlarını toplu olarak oluşturun.",
        bulkUploadGuide: "Toplu Yükleme Rehberi",
        step1: "Adım 1",
        downloadTemplate: "Excel şablonunu indir",
        downloadTemplateDesc: "Tüm gerekli sütun başlıkları önceden yapılandırılmış resmi şablonu indirin. Hiçbir sütun başlığını yeniden adlandırmayın veya kaldırmayın.",
        downloadTemplateBtn: "Şablonu İndir",
        step2: "Adım 2",
        fillExcelFile: "Excel dosyasını doldurun",
        fillExcelDesc: "Her satır bir depoyu temsil eder. Tüm sütunları doldurun — bin konumları için <code>Bin Names</code> sütununa tüm bin isimlerini virgülle ayırarak girin.",
        step3: "Adım 3",
        thingsToKeepInMind: "Dikkat edilmesi gerekenler",
        rulesDesc: "Yüklemeden önce dosyanızın bu kurallara uyduğundan emin olun.",
        step4: "Adım 4",
        uploadYourFile: "Dosyanızı yükleyin",
        uploadDesc: "Doldurduktan sonra aşağıdaki dosyayı yükleyin. Sistem tüm depoları ve bin konumlarını otomatik olarak oluşturacaktır.",
        rules: ["Depo başına sadece bir satır", "Bin isimleri tek hücrede virgülle ayrılmış", "Sütun başlıklarını yeniden adlandırmayın", "Aynı depodaki yinelenen bin isimleri atlanır", "Ülke kodu ile telefon numarası", "Sadece .xlsx veya .xls dosyaları kabul edilir"],
        dropFileHere: "Excel dosyanızı buraya bırakın",
        supports: ".xlsx ve .xls desteklenir — maksimum 10 MB",
        chooseFileUpload: "Dosya Seç & Yükle",
        parsing: "Dosya analiz ediliyor...",
        invalidFileType: "Geçersiz dosya türü. Lütfen Excel dosyası yükleyin.",
        noData: "Excel'de veri bulunamadı",
        failedToRead: "Excel dosyası okunamadı",
        unableToRead: "Dosya okunamadı.",
        reviewTitle: "Depo Verilerini İncele",
        reviewSubtitle: "İşletmenize aktarmadan önce son kontrol.",
        changeFile: "Dosyayı Değiştir",
        rowsFound: "satır bulundu",
        cancel: "İptal",
        finalizeImport: "Tamamla & İçe Aktar",
        importing: "İçe aktarılıyor...",
        success: "Başarılı",
        allWarehouseUploadedSuccess: "Tüm depolar başarıyla yüklendi",
        failed: "Başarısız",
        bulkUploadFailed: "Toplu yükleme başarısız",
        error: "Hata",
        binNamesNote: "<strong>Bin Names</strong> sütununda bir depoya ait tüm bin konumlarını tek hücreye virgülle ayırarak girin — örn: A1, A2, B1, RACK-01.",
        headers: { warehouseName: "Depo Adı", email: "E-posta", phoneNumber: "Telefon Numarası", location: "Konum", binNames: "Bin İsimleri" }
    },
    CustomerExcel: {
        title: "Müşterileri Yükle",
        description: "Excel dosyası kullanarak toplu müşteri oluşturmak için aşağıdaki adımları izleyin.",
        bulkUploadGuide: "Toplu Yükleme Rehberi",
        step1: "Adım 1",
        downloadTemplate: "Excel şablonunu indirin",
        downloadTemplateDesc: "Tüm gerekli sütun başlıkları önceden yapılandırılmış resmi şablonu edinin.",
        downloadTemplateBtn: "Şablonu İndir",
        step2: "Adım 2",
        fillExcelFile: "Excel dosyasını doldurun",
        fillExcelDesc: "Her satır bir müşteriyi temsil eder. Tüm sütunları gerektiği gibi doldurun.",
        step3: "Adım 3",
        thingsToKeepInMind: "Hatırlanması gerekenler",
        rulesDesc: "Yüklemeden önce, hataları önlemek için dosyanızın bu kurallara uygun olduğundan emin olun.",
        step4: "Adım 4",
        uploadYourFile: "Dosyanızı yükleyin",
        uploadDesc: "Doldurduktan sonra dosyayı aşağıya yükleyin. Sistem tüm müşterileri otomatik olarak oluşturacaktır.",
        rules: [
            "Sadece her müşteri için bir satır",
            "Sütun başlıklarını yeniden adlandırmayın",
            "Ülke kodlu telefon numarası",
            "Sadece .xlsx veya .xls dosyaları kabul edilir"
        ],
        dropFileHere: "Excel dosyanızı buraya bırakın",
        supports: ".xlsx ve .xls destekler — maks 10 MB",
        chooseFileUpload: "Dosya Seç ve Yükle",
        parsing: "Dosya ayrıştırılıyor...",
        invalidFileType: "Geçersiz dosya türü. Lütfen bir Excel dosyası yükleyin.",
        noData: "Excel'de veri bulunamadı",
        failedToRead: "Excel dosyası okunamadı",
        unableToRead: "Dosya okunamıyor.",
        reviewTitle: "Müşteri Verilerini İncele",
        reviewSubtitle: "İşletmenize aktarmadan önceki son kontrol.",
        changeFile: "Dosyayı Değiştir",
        rowsFound: "dosyada satır bulundu",
        cancel: "İptal",
        finalizeImport: "Tamamla ve İçe Aktar",
        importing: "İçe aktarılıyor...",
        success: "Başarılı",
        allCustomerUploadedSuccess: "Tüm müşteriler başarıyla yüklendi",
        failed: "Başarısız",
        bulkUploadFailed: "Toplu yükleme başarısız",
        error: "Hata",
        headers: {
            customerName: "Müşteri Adı",
            phoneNumber: "İletişim",
            address: "Adres",
            note: "Not"
        }
    },
    SupplierExcel: {
        title: "Tedarikçileri Yükle",
        description: "Excel dosyası kullanarak toplu tedarikçi oluşturmak için aşağıdaki adımları izleyin.",
        bulkUploadGuide: "Toplu Yükleme Rehberi",
        step1: "Adım 1",
        downloadTemplate: "Excel şablonunu indirin",
        downloadTemplateDesc: "Tüm gerekli sütun başlıkları önceden yapılandırılmış resmi şablonu edinin.",
        downloadTemplateBtn: "Şablonu İndir",
        step2: "Adım 2",
        fillExcelFile: "Excel dosyasını doldurun",
        fillExcelDesc: "Her satır bir tedarikçiyi temsil eder. Tüm sütunları gerektiği gibi doldurun.",
        step3: "Adım 3",
        thingsToKeepInMind: "Hatırlanması gerekenler",
        rulesDesc: "Yüklemeden önce, hataları önlemek için dosyanızın bu kurallara uygun olduğundan emin olun.",
        step4: "Adım 4",
        uploadYourFile: "Dosyanızı yükleyin",
        uploadDesc: "Doldurduktan sonra dosyayı aşağıya yükleyin. Sistem tüm tedarikçileri otomatik olarak oluşturacaktır.",
        rules: [
            "Sadece her tedarikçi için bir satır",
            "Sütun başlıklarını yeniden adlandırmayın",
            "Ülke kodlu telefon numarası",
            "Sadece .xlsx veya .xls dosyaları kabul edilir"
        ],
        dropFileHere: "Excel dosyanızı buraya bırakın",
        supports: ".xlsx ve .xls destekler — maks 10 MB",
        chooseFileUpload: "Dosya Seç ve Yükle",
        parsing: "Dosya ayrıştırılıyor...",
        invalidFileType: "Geçersiz dosya türü. Lütfen bir Excel dosyası yükleyin.",
        noData: "Excel'de veri bulunamadı",
        failedToRead: "Excel dosyası okunamadı",
        unableToRead: "Dosya okunamıyor.",
        reviewTitle: "Tedarikçi Verilerini İncele",
        reviewSubtitle: "İşletmenize aktarmadan önceki son kontrol.",
        changeFile: "Dosyayı Değiştir",
        rowsFound: "dosyada satır bulundu",
        cancel: "İptal",
        finalizeImport: "Tamamla ve İçe Aktar",
        importing: "İçe aktarılıyor...",
        success: "Başarılı",
        allSupplierUploadedSuccess: "Tüm tedarikçiler başarıyla yüklendi",
        failed: "Başarısız",
        bulkUploadFailed: "Toplu yükleme başarısız",
        error: "Hata",
        headers: {
            supplierName: "Tedarikçi Adı",
            phoneNumber: "İletişim",
            bankName: "Banka Adı",
            accountHolderName: "Hesap Sahibi Adı",
            accountNumber: "Hesap Numarası",
            note: "Not"
        }
    },
    VariantTemplate: {
        VariantTemplates: "Varyant Şablonları",
        Managereusablevariantpatterns: "Yeniden kullanılabilir varyant kalıplarını yönet",
        BinTransferHistory: "Bin Transfer Geçmişi",
        Trackmovementsacrossbins: "Bin'ler arası hareketleri takip et",
        SerialNumberHistory: "Seri Numarası Geçmişi",
        Trackproductserialnumberactivity: "Ürün seri numarası aktivitelerini takip et",
        Period: "Dönem",
        Nohistoryfound: "Geçmiş bulunamadı",
        Searchserialnumbers: "Seri numaralarını ara...",
        SerialNumbersHistory: "Seri Numaraları Geçmişi",
        Serialnumberhistoryglance: "Seri numarası geçmişine hızlı bakış.",
        Noserialnumbersfound: "Seri numarası bulunamadı",
        Noactivityhistoryfound: "Aktivite geçmişi bulunamadı",
        Statussetto: "Durum şu şekilde ayarlandı",
        Timeline: "Zaman Çizelgesi",
        Managereusableproductvariantpatterns: "Yeniden kullanılabilir ürün varyant kalıplarını yönet.",
        DeleteTemplate: "Şablonu Sil",
        Areyousureyouwanttemplate: "Bu şablonu silmek istediğinizden emin misiniz?",
        CreateNewTemplate: "Yeni Şablon Oluştur",
        CreateTemplate: "Şablon Oluştur",
        EditTemplate: "Şablonu Düzenle",
        UnlimitedTemplates: "Sınırsız Şablon",
        CreateAsManyTemplates: "İhtiyacınız kadar şablon oluşturun — Giyim, Ayakkabı, Elektronik ve daha fazlası.",
        PickWhileAddingProduct: "Ürün eklerken seçin",
        OpenTemplateLibrary: "Şablon kütüphanenizi açın ve varyant isimlerini saniyeler içinde seçin.",
        MixFromMultipleTemplates: "Birden fazla şablondan karıştır",
        SelectFromMultipleTemplates: "Tek bir ürün için birden fazla şablondan varyant isimleri seçin — tamamen esnek.",
        EditAnytime: "İstediğiniz zaman düzenleyin",
        RenameTemplatesAnytime: "Kataloğunuz değiştiğinde şablon isimlerini değiştirin, varyant isimleri ekleyin veya kaldırın.",
        StayConsistent: "Tutarlı kalın",
        SameVariantNamesAcrossAll: "Tüm ürünlerde aynı varyant isimleri. Yazım hatası yok, kopya yok, tahmin yok.",
        BuildOnceUseEverywhere: "Bir kere oluştur, her yerde kullan",
        StopReEnteringVariantNames: "Her ürün için aynı varyant isimlerini tekrar tekrar girmeyi bırakın. Bir şablon oluşturun, varyant isimlerini atayın ve anında yeniden kullanın.",
        Updateexistingvariantcombinations: "Mevcut varyant kombinasyonlarını güncelle",
        Definenewvariantcombinations: "Yeni varyant kombinasyonları tanımla",
        TemplateName: "Şablon Adı",
        AddVariantOptions: "Varyant Seçenekleri Ekle",
        SmallMedium: "örn. Small, Medium...",
        VariantsList: "Varyant Listesi",
        Nooptionsaddedyet: "Henüz seçenek eklenmedi",
        SaveTemplate: "Şablonu Kaydet",
        egSizesColorsetc: "örn. T-Shirt Bedenleri, Renkler vb.",
        Pleaseentertemplatename: "Lütfen şablon adı girin",
        Pleaseaddatleastonevariantoption: "Lütfen en az bir varyant seçeneği ekleyin",
        Templateupdatedsuccessfully: "Şablon başarıyla güncellendi",
        Templatecreatedsuccessfully: "Şablon başarıyla oluşturuldu",
        Failedtosavetemplate: "Şablon kaydedilemedi",
        Transfer: "Transfer",
        Editassignment: "Atamayı düzenle",
        Updateproductdetailsinbin: "Bin'deki ürün bilgilerini güncelle",
        Editinginbin: "Bin'de düzenleniyor",
        ConfirmUpdate: "Güncellemeyi Onayla",
        ConfirmAssign: "Atamayı Onayla",
        Assignanotherproduct: "Başka ürün ata",
        TransferBin: "Bin'i Transfer Et",
        SourceBin: "Kaynak Bin",
        DestinationBin: "Hedef Bin",
        SelectSourceBin: "Kaynak Bin Seç",
        SelectDestinationBin: "Hedef Bin Seç",
        Unit: "Birim",
        ManageVariant: "Varyantı Yönet",
        CreateSKUvariationsyourproduct: "Ürününüz için SKU varyasyonları oluşturun",
        Assigningvariationsto: "Varyasyonlar atanıyor",
        Novariantsaddedyet: "Henüz varyant eklenmedi",
        AddedVariants: "Eklenen Varyantlar",
        AddVariantsfromTemplate: "Şablondan Varyant Ekle",
        Pickatemplateandselectvariantnames: "Bir şablon seçin ve varyant isimlerini seçin",
        ChooseaTemplate: "Şablon Seç",
        Selectvariantnamestoadd: "Eklenecek varyant isimlerini seçin",
        SelectatemplatetopickvariantnamesfroYoucanaddfrommultiple: "Varyant isimlerini seçmek için bir şablon seçin. Birden fazla şablondan ekleyebilirsiniz.",
        Loadingtemplates: "Şablonlar yükleniyor...",
        Backtotemplates: "Şablonlara dön",
        Selectallindividualadd: "Hepsini veya tek tek varyant isimlerini seçerek ekleyin.",
        VariantNames: "Varyant İsimleri",
        MediaDescription: "Medya & Açıklama",
        Addattachmentsandproductnotes: "Ekler ve ürün notları ekle",
        ProductMedia: "Ürün Medyası"
    },
    AddProductGuide: {
        title: "Kaydettikten sonra başlangıç stokunu ekle",
        description: "Ürünlerde burada miktar alanı yoktur. Kaydettikten sonra, açılış stokunuzu kaydetmek için 'Stok Girişi'ni kullanın — konum ve takip üzerinde tam kontrol.",
        steps: {
            quantity: { title: "Miktar", sub: "Açılış stok sayısını ayarla" },
            binLocation: { title: "Bin Konumu", sub: "Koridor, raf, raf — örn. A-01-03" },
            serialNumbers: { title: "Seri Numaraları", sub: "Her birimi bireysel takip et" },
            warehouse: { title: "Depo", sub: "Hangi konumda depolandığı" },
            batchExpiry: { title: "Parti / Son Kullanma", sub: "Stoku parti numarasına göre grupla" }
        },
        actions: { close: "Kapat" }
    },
    Remainingtranferitems: {
        NoTransferOrdersFound: "Transfer Emri Bulunamadı",
        Itemshistory: "Depolar arasında transfer ettiğiniz ürünler takip ve geçmiş için burada görünecektir.",
        CreateTransfer: "Transfer Oluştur"
    },
    ManufactureLocal: {
        TaponproducttoManufacture: "Üretmek için ürüne dokunun",
        Selectproductfrombelow: "Aşağıdaki listeden ürünü seçin",
        SetupANewProduct: "Yeni Ürün Kurun",
        DefineAProductAdditsrawmaterial: "Bir Ürün Tanımlayın ve ham maddelerini ekleyin",
        ManufacturingSetup: "Üretim Kurulumu",
        Pickproducttodefineitsproductiondetails: "Üretim detaylarını tanımlamak için bir ürün seçin",
        ConfigureManufacturing: "Üretimi Yapılandır",
        SelectRawMaterial: "Ham Madde Seç",
        NoRawMaterials: "Ham Madde Yok",
        Definecomponentsneededtoproduct: "Bu ürünü üretmek için gereken bileşenleri tanımlayın.",
        NoAdditionalCosts: "Ek Maliyet Yok",
        Addlaboroverheadlogisticalcharges: "İşçilik, genel gider veya lojistik ücretleri ekleyin.",
        AddAdditionalCost: "Ek Maliyet Ekle",
        AddCost: "Maliyet Ekle",
        TotalPrice: "Toplam Fiyat",
        SelectCharges: "Ücretleri Seç",
        EnterEstimatedCost: "Tahmini Maliyeti Girin",
        QtyRequried: "Gerekli Mik.",
        Manufacturing: "Üretim",
        Outputfinishedgoodsdestination: "Bitmiş ürün varış noktası",
        Manufacturingquantity: "Üretim miktarı",
        Storefinishedgoodsat: "Bitmiş ürünleri şurada depola",
        Rawmaterials: "Ham maddeler",
        StockSelection: "Stok Seçimi",
        AdditionalCosts: "Ek Maliyetler",
        Quantityconsume: "Tüketilen miktar",
        Totalmanufacturingcost: "Toplam üretim maliyeti",
        Sumofrawmaterialcosts: "Tüm ham madde maliyetlerinin toplamı",
        CustomManufacturingCharge: "Özel Üretim Ücreti",
        Addextralikelaboroverheadrepairs: "İşçilik, genel gider veya onarım gibi ekstra maliyetler ekleyin.",
        CalculatedTotal: "Hesaplanan Toplam",
        AddRawMaterial: "Ham Madde Ekle",
        ConfigureRawMaterial: "Ham Maddeyi Yapılandır",
        Thisoutputunit: "Bu, çıktı birimi başına gereken temel miktardır.",
        ChangeProduct: "Ürünü Değiştir",
        AddtoList: "Listeye Ekle",
        ManufacturedSuccessfully: "Başarıyla Üretildi",
        Manufacture: "Üretim",
        EditDeleteHistory: "Düzenleme/Silme Geçmişi",
        ManageOrder: "Siparişi Yönet",
        ManageBatch: "Partiyi yönet",
        Paymentnotavailablehere: "Burada ödeme mevcut değil",
        Thisrecordisanorderorderitself: "Bu kayıt bir siparişten geliyor. Ödeme yalnızca siparişten kaydedilebilir.",
        Torecorpaymenttheorderthethere: "Ödeme kaydetmek için bağlı siparişe gidin ve orada <b>Ödeme Kaydet</b> seçeneğini kullanın.",
        GotoOrder: "Siparişe git"
    },
    ReplaceReturnLocal: {
        ReplacedWith: "Şununla Değiştirildi",
        Noreplacementhistoryfound: "Değişim geçmişi bulunamadı",
        Noreturnhistoryfound: "İade geçmişi bulunamadı",
        Productbeingreturned: "İade edilen ürün",
        Required: "Gerekli",
        Selectreturnedproduct: "İade edilen ürünü seçin",
        Searchnamescanbarcode: "İsim, SKU ile arayın veya barkod tarayın",
        Browse: "Gözat",
        Stockhandling: "Stok girişi işleme",
        Stockinreturnedproduct: "İade edilen ürünü stoka al",
        Ontoinventory: "Açık — iade edilen ürün envantere geri eklenecek",
        Offreturnedonly: "Kapalı — ürün sadece iade olarak kaydedilecek",
        Usedrestock: "Yeniden stoklamada kar düzeltmesini hesaplamak için kullanılır",
        Willaddedbackconfirmation: "Onaylandığında envantere geri eklenecek",
        Returnreason: "İade nedeni",
        Optional: "İsteğe bağlı",
        SelectReason: "Neden Seçin",
        Additionalnotes: "Ek notlar",
        Describeofcustomerexplanation: "İade edilen ürünün durumunu, görünür hasarları, müşteri açıklamasını vb. belirtin...",
        Requiredmustfilledcontinue: "Devam etmek için gerekli alanlar doldurulmalıdır",
        Reviewdetailsbeforeconfirming: "Onaylamadan önce ayrıntıları inceleyin",
        Replacementproductwilldeductedinventoryconfirmation: "Değişim ürünü onaylandığında envanterinizden düşülecektir.",
        Choosereplacementproduct: "Değişim ürününü seçin",
        Willdeductedfrominventoryconfirm: "Onaylandığında envanterden düşülecek",
        Thesewillattachedothereturnrecord: "Bu görseller iade kaydına eklenecektir",
        Replacementitem: "Değişim öğesi",
        Addanotherproduct: "Başka ürün ekle",
        Replacementproductwillbe: "Değişim ürünü onaylandığında envanterden",
        deducted: "düşülecektir",
        fromyourinventoryconfirmation: ".",
        productadjustedusingprice: "İade edilen ürün yeniden stoklanacak ve kar orijinal satış fiyatı kullanılarak düzeltilecektir.",
        Willloggedreturnedonlynotrestocked: "Sadece iade olarak kaydedilecek — yeniden stoklanmayacak",
        Returnonly: "Sadece iade",
        Imagesofreturnedproduct: "İade edilen ürünün görselleri",
        Returnedproductwill: "İade edilen ürün yeniden stoklanmayacak —",
        not: "sadece",
        berestockedloggedreturnedonly: "iade olarak kaydedilecektir.",
        AddImage: "Görsel Ekle",
        STOCKIN: "STOKA AL",
        LOGONLY: "SADECE KAYDET",
        ContinuetoReview: "İncelemeye Devam Et →",
        Confirmreplacement: "Değişimi onayla",
        Confirmreturn: "İadeyi onayla",
        Filldetailsbelowproceed: "Devam etmek için aşağıdaki ayrıntıları doldurun",
        Review: "İncele",
        editdetails: "ayrıntıları düzenle",
        Configurereturndetails: "İade detaylarını yapılandır",
        Configurereplacementdetails: "Değişim detaylarını yapılandır",
        SelectSource: "Kaynak Seç",
        Returning: "İade Ediliyor",
        Replacement: "Değişim",
        WalkCustomer: "Mağaza Müşterisi",
        RETURNEDPRODUCT: "İADE EDİLEN ÜRÜN",
        REPLACEMENTPRODUCT: "DEĞİŞİM ÜRÜNÜ",
        STOCKOUT: "STOK ÇIKIŞI",
        Netinventoryimpact: "Net envanter etkisi",
        Replacementitemcost: "Değişim öğesi maliyeti",
        Returneditemrestockvalue: "İade edilen öğe yeniden stoklama değeri",
        PROFITINVENTORYSUMMARY: "KAR VE ENVANTER ÖZETİ",
        Inventoryaction: "Envanter eylemi",
        Valuededucted: "Düşülen değer",
        Profitadjustment: "Kar düzeltmesi",
        stockedout: " stoktan düşüldü",
        restocked: " yeniden stoklandı",
        Noaction: "Eylem yok",
        Valuebeingreturned: "İade edilen değer",
        Willberestocked: "Yeniden stoklanacak",
        Willbe: "Olacak",
        logged: "kaydedildi",
        ON: "AÇIK",
        OFF: "KAPALI",
        Linked: "Bağlantılı",
        Pleaseselectreturnedproduct: "Lütfen iade edilen bir ürün seçin",
        Quantityrequired: "Miktar gereklidir",
        Buyingpricerequired: "Alış fiyatı gereklidir",
        Pleaseaddleastreplacementproduct: "Lütfen en az bir değiştirme ürünü ekleyin",
        Pleaseconfigurereturnedproductdetails: "Lütfen iade edilen ürün detaylarını yapılandırın",
        Pleaseselectcustomer: "Lütfen bir müşteri seçin",
        Returndateisrequired: "İade tarihi gereklidir",
        Pleasefillallrequiredfields: "Lütfen tüm zorunlu alanları doldurun",
        Wildeductedfrominventory: "Envanterden düşülecek",
        Currentprice: "Mevcut fiyat",
        Defectivedamaged: "Arızalı / hasarlı",
        Wrongitemreceived: "Yanlış ürün alındı",
        Customerchangedmind: "Müşteri fikrini değiştirdi",
        Sizefitissue: "Beden / uyum sorunu",
        Notasdescribed: "Açıklamaya uymuyor",
        Other: "Diğer",
        Originalsaleprice: "Orijinal satış fiyatı (kar düzeltmesi)",
        Addedbackinventory: "Envantere tekrar eklendi",
        Notaddedinventory: "Envantere eklenmedi",
        replacedwith: "ile değiştirildi",
        deductedfrominventory: "envanterden düşüldü",
        RETURNWITHSTOCKIN: "İADE · STOK GİRİŞİ İLE",
        RETURNNOSTOCKIN: "İADE · STOK GİRİŞİ YOK",
        MULTIPLEREPLACEMENTS: "ÇOKLU DEĞİŞİMLER",
        SINGLEREPLACEMENT: "TEK DEĞİŞİM",
        InternalTrackingRecordInfo: "This is a record for internal tracking. This process DOES NOT automatically update or delete related invoices, orders, or accounts.",
        ManualStepsIfNeeded: "Manual Steps (if needed):",
        ManualStep1: "Return/Delete invoice from Sale History",
        ManualStep2: "Adjust customer ledger manually",
        ManualStep3: "Update related purchase record",
        RETURNEDSTOCKIN: "İADE EDİLDİ · STOK İÇERİ",
        REPLACEMENTSTOCKOUT: "DEĞİŞİM · STOK ÇIKIŞI",
        Returnonlylogsthisentry: "İade yalnızca bu girişi günlüğe kaydeder —",
        nostockwillbeaddedorremoved: "hiçbir stok eklenmeyecek veya çıkarılmayacaktır",
        frominventory: "envanterden.",
        Whentousethis: "Bunu ne zaman kullanmalı:",
        UseReturnenddayrecorditemsoutsalesthatcamebackunusablewantinventory: "Satış için gönderilen ancak hasarlı veya kullanılamaz durumda geri gelen ürünleri kaydetmek için gün sonunda İade'yi kullanın — izlemek istediğiniz ancak envantere geri ekleyemediğiniz ürünler.",
        Youcanviewallpastreturnentriesin: "Geçmiş tüm iade girişlerini şurada görebilirsiniz:",
        ReturnHistory: "İade Geçmişi",
        underthe: "altında",
        Others: "Diğerleri",
        tab: "sekmesi.",
        Negativestocktransactiondisabled: "Negatif hisse senedi işlemleri devre dışı bırakıldı."
    },
    NewRLocal: {
        Originalsaleprice: "Orijinal satış fiyatı",
        Editinghistoryonlyinventorystaysunchanged: "Yalnızca geçmişi düzenliyor — envanter değişmeden kalır.",
        Changeshereupdatethisdetailsquantitiesaffected: "Buradaki değişiklikler yalnızca bu kaydın ayrıntılarını (neden, tarih, notlar) günceller. Gerçek stok miktarlarınız, raf konumlarınız ve ürün verileriniz etkilenmez.",
        Needtofixinventorylevelsinstead: "Bunun yerine envanter seviyelerini düzeltmeniz mi gerekiyor?",
        AdjustStock: "Stoku Ayarla",
        Refund: "İade",
        ImportantNote: "Önemli Not",
        Pleasereviewbeforecontinuing: "Devam etmeden önce lütfen inceleyin",
        Onceshippedreceivedanyupdatesmadeorder: "Bir sipariş sevk edildikten veya alındıktan sonra, siparişte yapılan herhangi bir güncelleme işlem geçmişine yansımaz.",
        Thisundone: "Bu, siparişi kalıcı olarak kaldıracaktır. Bu işlem geri alınamaz.",
        Inventorywilladjustedautomatically: "Envanter otomatik olarak ayarlanmayacak",
        Deletingthisreversevedshippedyouwillneed: "Bunu silmek stok değişikliklerini geri almaz. Öğeler zaten alındıysa/sevk edildiyse, şunları yapmanız gerekecektir:",
        reflectthecorrectstocklevels: "doğru stok seviyelerini yansıtmak için.",
        manuallyadjustyourinventory: "envanterinizi manuel olarak ayarlayın",
        Addremovestockforitemsthatwereshipped: "Sevk edilen öğeler için stok ekle/çıkar",
        Addremovestockforitemsthatwerereceived: "Alınan öğeler için stok ekle/çıkar",
        Updatecostrecordspaymentwaalreadymade: "Ödeme zaten yapılmışsa maliyet kayıtlarını güncelle",
        Reconcilerecordsandoutstandingpayments: "Kayıtları ve ödenmemiş ödemeleri uzlaştır"
    },
    ReceivablesLocal: {
        Receivables: "Alacaklar",
        Manageandtrackcustomerduebalances: "Müşteri vadesi geçmiş bakiyelerini yönetin ve takip edin",
        Viewcustomerduebalancereport: "Müşteri vadesi geçmiş bakiye raporu görüntüle",
        Viewsupplierduebalancereport: "Tedarikçi vadesi geçmiş bakiye raporu görüntüle",
        DueBalance: "Vadesi Geçmiş Bakiye",
        Unpaid: "Ödenmemiş",
        PartiallyPaid: "Kısmen Ödenmiş",
        Paid: "Ödenmiş",
        HighestBalance: "En Yüksek Bakiye",
        LowestBalance: "En Düşük Bakiye",
        Filldetailsrecordpayment: "Ödemeyi kaydetmek için detayları doldurun",
        NewPaymentEntry: "Yeni Ödeme Kaydı",
        EditPaymentEntry: "Ödeme Kaydını Düzenle",
        Nosuppliersfound: "Tedarikçi bulunamadı",
        Nocustomersfound: "Müşteri bulunamadı",
        LowtoHigh: "Düşükten Yükseğe",
        HightoLow: "Yüksekten Düşüğe",
        AttachmentUploadedSc: "Ek dosya başarıyla yüklendi",
        AttachmentUploadedF: "Ek dosya yüklenemedi",
        Pay: "Öde",
        NoBillsFound: "Fatura Bulunamadı",
        Thiscustomerhasunpaidbills: "Bu müşterinin ödenmemiş faturası yok.",
        TotalDue: "Toplam Borç",
        BillsFound: "Faturalar Bulundu",
        DeselectAll: "Tüm Seçimleri Kaldır",
        SelectAll: "Tümünü Seç",
        ShowDetails: "Detayları Göster"
    },
    AssetsNewLocal: {
        Assignedon: "Atandığı tarih",
        Total: "Toplam",
        Assigned: "Atandı",
        Remaining: "Kalan",
        Available: "Mevcut",
        NoSerialNumbers: "Seri numarası yok",
        UpdateExistingAssetDetails: "Mevcut varlık detaylarını güncelle",
        RegisterNewBusinessAsset: "Yeni işletme varlığı kaydet",
        BasicInformation: "Temel Bilgiler",
        AssetDetails: "Varlık Detayları",
        Quantity: "Miktar",
        SerialNumbers: "Seri Numaraları",
        SerialNumberPlaceholder: "Seri numarası",
        AddSerialNumber: "Seri Numarası Ekle",
        SerialNumbersOptional: "Seri numaraları isteğe bağlıdır. En fazla şu kadar ekleyebilirsiniz:",
        AssetImages: "Varlık Görselleri",
        AdditionalNotes: "Ek Notlar",
        AdditionalNotesPlaceholder: "Ek detaylar veya bakım geçmişi...",
        Updating: "Güncelleniyor...",
        Adding: "Ekleniyor...",
        ITEquipmentPlaceholder: "örn. BT Ekipmanı",
        LoadingMoreActivities: "Daha fazla etkinlik yükleniyor...",
        AssignedAssets: "Atanan Varlıklar",
        Noassetsassignedstaffmember: "Bu personele atanmış varlık yok.",
        Assignassetstaff: "Personele varlık ata",
        Returnassetfromstaff: "Bu varlığı personelden iade et",
        AssignmentDetails: "Atama Detayları",
        Serial: "Seri No",
        ViewAssets: "Tüm Varlıkları Görüntüle",
        ViewByStaff: "Personele Göre Görüntüle",
        AssignedHistory: "Atama Geçmişi",
        Returned: "İade Edildi",
        Returnedon: "İade Tarihi",
        ReturnedBy: "İade Eden",
        AssignedTo: "Atanan",
        NoHistoryRecords: "Geçmiş kaydı yok",
        Selectstaffmemberviewtheirassets: "Varlıklarını görüntülemek için bir personel seçin",
        Deleted: "SİLİNDİ",
        searchPlaceholder: "Varlığı ad veya seri numarasına göre ara..."
    },
    InventoryCountLocale: {
        InventoryCount: "Stok Sayımı",
        Viewinventorycountreport: "Stok sayım raporunu görüntüle",
        ItemsCount: "Ürün Sayısı",
        All: "Tümü",
        InProgress: "Devam Ediyor",
        Submitted: "Gönderildi",
        awaitingreview: "İnceleme Bekliyor",
        EditInventoryCount: "Stok Sayımını Düzenle",
        NewInventoryCount: "Yeni Stok Sayımı",
        Modifyinventorycountsheetdetails: "Sayım sayfası detaylarını düzenle",
        Startanewinventorycountsheet: "Yeni stok sayım sayfası başlat",
        GeneralInformation: "Genel Bilgiler",
        Title: "Başlık",
        SaveChanges: "Değişiklikleri Kaydet",
        Selectproductsforthisinventorycountsheet: "Bu sayfa için ürünleri seç",
        InventoryCountDetails: "Stok Sayım Detayları",
        Inventorycountsheetdetails: "Stok sayım sayfası detayları",
        Viewingdetailsforcountsheet: "Sayım sayfası detaylarını görüntüleme",
        Started: "Başladı",
        TaskSheets: "Görev Sayfaları",
        Allitems: "Tüm ürünler",
        NotStarted: "Başlamadı",
        Completed: "Tamamlandı",
        Results: "Sonuçlar",
        ViewResults: "Sonuçları Görüntüle",
        DeleteInventoryCount: "Stok Sayımını Sil",
        Viewingtransactionandadjustments: "İşlem kayıtları ve stok düzeltmelerini görüntüleme",
        Productsadjusted: "Düzeltilen ürünler",
        Assignee: "Atanan",
        Tasksheetdetails: "Görev sayfası detayları",
        Draft: "Taslak",
        VariantQuantities: "Varyant Miktarları",
        AssignedProducts: "Atanan Ürünler",
        ReturnAsset: "Varlığı İade Et",
        EditTasksheet: "Görev Sayfasını Düzenle",
        NewTasksheet: "Yeni Görev Sayfası",
        Updatetasksheetdetails: "Görev sayfası detaylarını güncelle",
        Starttasksheetforthisinventorycount: "Bu sayım için yeni görev sayfası başlat",
        TaskSheetInformation: "Görev Sayfası Bilgileri",
        SheetTitle: "Sayfa Başlığı",
        Entersheettitle: "Sayfa başlığını girin",
        SubmissionResult: "Gönderme Sonucu",
        ReviewChanges: "Değişiklikleri İncele",
        Viewingsubmissionresultsforthisinventorycount: "Bu sayım için gönderme sonuçlarını görüntüleme",
        Reviewyourinventorycountbeforesubmitting: "Göndermeden önce stok sayımınızı gözden geçirin"
    },
    NewMissingLocale: {
        Failedtoloadcounts: "Sayım yüklenemedi",
        NoInventoryCounts: "Stok Sayımı Yok",
        NoMatches: "Eşleşme Yok",
        Therearenoinventorycountswiththestatus: "Bu durumda stok sayımı bulunmuyor",
        Noinventorycountsfoundyoursearchterm: "Arama teriminizle eşleşen stok sayımı bulunamadı",
        Thereareinventorycountsrecordedyetforthisbusiness: "Bu işletme için henüz stok sayımı kaydedilmedi"
    },
    StockinModalP: {
        StockInNow: "Şimdi Stok Girişi Yap",
        Settheopeningquantityforthisproductrightnow: "Bu ürün için başlangıç miktarını şimdi ayarlayın.",
        Addinitialstock: "Başlangıç stoğu ekle?",
        dothislater: "Bunu sonra yapacağım",
        Productadded: "Ürün eklendi!",
        isready: "hazır.",
        SeeHowItWorks: "Nasıl Çalıştığını Gör",
        NoSalesOrdersFound: "Satış Siparişi Bulunamadı",
        NoPurchaseOrdersFound: "Satın Alma Siparişi Bulunamadı",
        Startcreatingoutgoinginventoryrevenue: "Satış siparişleri oluşturmaya başlayın, böylece çıkan envanterinizi ve gelirinizi takip edebilirsiniz.",
        Trackrestockssupplierplace: "Envanter yenilemeleri ve tedarikçi siparişlerini tek bir yerde takip edin.",
        CreateSalesOrder: "Satış Siparişi Oluştur",
        CreatePurchaseOrder: "Satın Alma Siparişi Oluştur",
    }
    ,
    dialy_report: "Günlük Hareket Raporu",
    Quotation: "Teklif",
    Quote: "Teklif",
    Assignee: "Atanan",
    dayStart: "Gün başlangıcı",

    ShowTotalAmount: "Toplam Tutarı",


    tutorial: {
        watchTitle: 'Adım adım eğitimleri izleyin',
        watchDesc: 'YouTube kanalımızda SimplyStock\'u öğrenin',
        modalTitle: 'SimplyStock ile bir adım önde olun',
        modalDesc: 'Bıraktıkları anda yeni eğitimler almak için abone olun',
        feature1Title: 'Yeni özellik incelemeleri',
        feature1Sub: 'Her yeni güncelleme kısa bir video ile açıklandı, böylece yenilikleri asla kaçırmazsınız',
        feature2Title: 'Hızlı nasıl yapılır videoları',
        feature2Sub: 'Stok, fatura, personel erişimi ve daha fazlasını 5 dakikadan kısa sürede ayarlayın',
        feature3Title: 'Anında Bildirimler',
        feature3Sub: 'Yeni bir öğretici yayınlandığı anda bildirim alın — kendi hızınızda öğrenin',
        feature4Title: '% 100 ücretsiz, her zaman',
        feature4Sub: 'Tüm öğreticiler sonsuza kadar ücretsizdir — oturum açma veya abonelik gerekmez',
        subscribeBtn: 'SimplyStock\'a abone olun',
        maybeLater: 'Belki sonra'
    }
    ,
    dailyCashReport: {
        "title": "Günlük Kasa Raporu",
        "subtitle": "Kim, ne zaman, ne kadar ödedi ve kalan borç ne kadar — Satış Detaylarından gruplandırılmıştır.",
        "totalSales": "Toplam satış",
        "cashReceived": "Toplam Alınan",
        "outstanding": "Bekleyen",
        "collectionRate": "Tahsilat oranı",
        "grandTotalAllDates": "GENEL TOPLAM (tüm tarihler)",
        "totalLabel": "Toplam",
        "loading": "Yükleniyor...",
        "noData": "Seçilen tarih aralığı için veri bulunamadı.",
        "loadingMore": "Daha fazla yükleniyor..."
    },
    dailyCashReportColumns: {
        "date": "Tarih",
        "customer": "Müşteri",
        "productsSold": "Satılan Ürünler",
        "products": "Ürünler",
        "salesAmount": "Satış Tutarı",
        "sales": "Satışlar",
        "received": "Toplam Alınan",
        "receivedShort": "Tahsil Edildi",
        "debited": "Deftere Borç Kaydedildi",
        "due": "Borç",
        "paymentModes": "Ödeme Yöntemi",
        "mode": "Yöntem"
    }
}
export default tr
